<template>
    <div class="approval_process_wrap">
        <div class="approval_process_left" @mousedown="handleMouseDown"  ref="approval_process_left">
            <approveAdminProcessNode  :canOperate="canOperate" :node="nodeInfoData" :nodeUuid="nodeUuid" @handleClickNode="handleClickNode" @nodeReceiveData="nodeReceiveData"></approveAdminProcessNode>
        </div>
        <div class="approval_process_right">
          <template v-if="approvalProcessType == 'start'">
              <el-form :model="startProcessForm"  label-position="top" ref="startProcessForm"   size="small" class="approval_process_form">
                  <div class="approval_process_title">提交</div>
                  <div class="approval_process_form_wrap">
                  <div class="tab_list_wrap">
                      <ul>
                          <li  :class="{'active':tabActive === 1}" @click="tabActive = 1">审批人设置</li>
                          <li v-if="approvalType == ''" :class="{'active':tabActive === 2}" @click="tabActive = 2">表单权限</li>
                      </ul>
                  </div>
                  <template v-if="tabActive == 1">
                      <div class="cc_list_wrap mt_16">
                          <ul>
                              <li v-for="(item,ccIndex) in startProcessForm.cc_info" :key="ccIndex">
                                  <div class="cc_list_title">
                                      <span>抄送人</span>
                                      <span class="handle_icon_wrap" @click="handleClickDelCCInfo('startProcessForm',ccIndex)">
                                      <i class="iconfont icon-shanchu1"></i>
                                  </span>
                                  </div>
                                  <el-form-item prop="type" class="cc_list_radio">
                                      <el-radio-group v-model="item.type">
                                          <el-radio :label="userType.value" :disabled="startProcessForm.cc_info.find((find,findIndex) => (find.type == userType.value && findIndex!=ccIndex)) ? true : false" v-for="userType in userTypeList" @change="handleChangeCCUserType(item)">{{userType.label}}
                                              <el-tooltip class="item" effect="dark" placement="top-start" v-if="userType.value == 'user_tags'">
                                                  <div slot="content">
                                                      如何使用？<br>
                                                      1、在人事管理->人员标签中设置标签，可以将相同职能的人设置为同一个标签<br>
                                                      2、标签中的人员均可收到该审批抄送
                                                  </div>
                                                  <i class=" iconfont icon-bangzhuzhongxin"></i>
                                              </el-tooltip>
                                          </el-radio>
                                      </el-radio-group>
                                  </el-form-item>

                                   <!--选择提交人自选-->
                                  <template  v-if="item.type==='submitter_choice'">
                                      <el-form-item label="添加成员" prop="is_single" class="form_item_border_top label-bold" >
                                            <!--  @change="()=>{item.relate_id=[];item.relate_ids=''}"-->
                                          <el-radio-group v-model="item.is_single">
                                              <el-radio :label="1">单人</el-radio>
                                              <el-radio :label="2">多人</el-radio>
                                          </el-radio-group>
                                      </el-form-item>
                                      <el-form-item label="选择范围" prop="is_all_company" class="form_item_border_top label-bold" >
                                          <el-radio-group  v-model="item.is_all_company" @change="()=>{item.relate_id=[];item.relate_ids=''}">
                                              <el-radio :label="1">全公司</el-radio>
                                              <el-radio :label="2">指定成员</el-radio>
                                          </el-radio-group>
                                      </el-form-item>
                                      <!-- 选择的  添加成员是单人/多人~ 选择范围是指定成员时-->
                                      <el-form-item :label="item.is_single == 1 ? '添加成员（可多选）' :'添加成员（可多选）'"   prop="assign_users"  class="form_item_border_top label-bold"  v-if="item.is_all_company == 2">
                                          <ul class="approve_user_list">
                                              <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                                  <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                  <span v-text="user.relate_name"></span>
                                                  <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                              </li>
<!--                                              v-if="(item.is_single == 1 && item.relate_id.length == 1) ? false : true"-->
                                              <li class="add_approve_btn" >
                                                  <el-popover placement="top"  :ref="'userPopover' + ccIndex"  trigger="click">
                                                      <i class="el-icon-plus" slot="reference"></i>
                                                      <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                      <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                      </el-option>
                                                  </el-select>
                                                  </el-popover>
                                              </li>
                                          </ul>
                                      </el-form-item>
                                  </template>

                                  <!--指定成员选择人员-->
                                  <el-form-item prop="cc_users" label="添加成员（可多选）" class="form_item_border_top label-bold" v-if="item.type === 'specified'">
                                      <ul class="approve_user_list">
                                          <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                              <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                              <span v-text="user.relate_name"></span>
                                              <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                          </li>
                                          <li class="add_approve_btn">
                                              <el-popover placement="top"  :ref="'userPopover'+ccIndex"   trigger="click">
                                                  <i class="el-icon-plus" slot="reference"></i>
                                                  <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                      <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                      </el-option>
                                                  </el-select>
                                              </el-popover>
                                          </li>
                                      </ul>
                                  </el-form-item>

                                  <!--人员标签/人员标签-->
                                  <el-form-item prop="cc_role_ids" label="人员标签" class="form_item_border_top label-bold" v-if="item.type === 'user_tags'">
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              选择人员标签：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select :key="'cc_role_ids' + ccIndex" filterable multiple placeholder="请选择人员标签"  collapse-tags   v-model="item.relate_ids" @remove-tag="handleSelectCCRemoveTags($event,item,ccIndex)">
                                                  <el-option :key="role.id" :label="role.name" :value="role.id" @click.native="handleSelectCCTags(role,item,ccIndex)"  v-for="role in roleList"></el-option>
                                              </el-select>
                                              <p class="del_relate_class" v-if="item.del_relate_id && item.del_relate_id.length > 0">
                                                  人员标签被删除:
                                                  <span v-text="item.del_relate_id.map(map => map.relate_name).join(',')"></span>
                                              </p>
                                          </div>
                                       </div>
                                  </el-form-item>

                                  <!--连续多级上级-->
                                  <el-form-item prop="successive_superior" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_superior'">
                                      <p class="quick_tips">设置后，该节点将从直属上级到已选的层级依次审批</p>
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              提交人的：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select :key="'successive_superior' + ccIndex"  placeholder="请选择" remote v-model="item.relate_ids_string">
                                                  <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id"  @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)"  v-for="level in multiLevelSuperiorList"></el-option>
                                              </el-select>
                                          </div>
                                      </div>
                                  </el-form-item>

                                  <!--连续多级部门-->
                                  <el-form-item prop="successive_department" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_department'">
                                      <p class="quick_tips">设置后，该节点将从直属部门负责人到已选层级的部门负责人依次审批</p>
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              提交人的：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select  :key="'successive_department' + ccIndex" placeholder="请选择" remote v-model="item.relate_ids_string">
                                                  <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id" @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)" v-for="level in multiLevelDepartmentsList"></el-option>
                                              </el-select>
                                          </div>
                                      </div>
                                  </el-form-item>

                              </li>
                          </ul>
                      </div>
                      <div class="prompt_text">
                          提示：<br>
                          在发起后即会抄送给设置人员（可添加多种抄送人）
                      </div>
                      <div class="mt_16">
                          <el-button v-if="startProcessForm.cc_info.length<8" type="text"   @click="handleClickAddCCInfo('startProcessForm')"><i class="el-icon-plus"></i>添加抄送人</el-button>
                      </div>
                  </template>
                  <template v-if="tabActive == 2">
                      <div class="permissions_form">
                          <ul>
                              <li class="permissions_form_top">
                                  <div class="field_name">表单字段</div>
                                  <div class="field_read_only" @click="handleClickFieldAuth(1)"><el-radio v-model="permissions_form_radio" :label="1">只读</el-radio></div>
                                  <div class="field_editable" @click="handleClickFieldAuth(2)"><el-radio v-model="permissions_form_radio" :label="2">可编辑</el-radio></div>
                                  <div class="field_hide" @click="handleClickFieldAuth(3)"><el-radio  v-model="permissions_form_radio" :label="3">隐藏</el-radio></div>
                              </li>
                              <li v-for="item in field_auth">
                                 <div class="field_name" v-text="fieldAuthList.find(find => find.field_key == item.field_key) ? fieldAuthList.find(find => find.field_key == item.field_key).field_name :''"></div>
                                 <div class="field_read_only"><el-radio v-model="item.field_auth" :label="1">只读</el-radio></div>
                                 <div class="field_editable"><el-radio v-model="item.field_auth" :label="2">可编辑</el-radio></div>
                                 <div class="field_hide"><el-radio v-model="item.field_auth" :label="3">隐藏</el-radio></div>
                              </li>

                          </ul>
                      </div>
                  </template>
                  </div>
              </el-form>
          </template>

          <template v-if="approvalProcessType == 'approval'">
              <el-form :model="approvalForm"  label-position="top" ref="approvalForm"   size="small" class="approval_process_form">
                  <div class="approval_process_title">
                      <div class="approval_process_title_edit" :class="approvalForm.is_edit ? 'width_flex_1' : ''">
                          <span v-if="!approvalForm.is_edit" v-text="approvalForm.name"></span>
                          <span class="handle_icon_wrap"  v-if="!approvalForm.is_edit">
                              <i @click="handleClickEditTitle(approvalForm)" class="iconfont icon-bianji"></i>
                          </span>
                          <el-input @blur="handleTitleBlur($event,approvalForm)"
                                    @keyup.enter.native="handleTitleBlur($event,approvalForm)"
                                    clearable
                                    maxlength="10"
                                    placeholder="请输入标题"
                                    ref="titleInput"
                                    size="small"
                                    v-if="approvalForm.is_edit"
                                    v-model="approvalForm.name">
                          </el-input>
                      </div>
                  </div>
                  <div class="approval_process_form_wrap">
                      <el-form-item prop="cc_role_ids" label="">
                          <el-radio-group  v-model="approvalForm.handle.operation_type" @change="handleChangeOperationType">
                              <el-radio label="manual_approval">人工审批</el-radio>
                              <el-radio label="auto_approve">自动通过</el-radio>
                              <el-radio label="auto_deny">自动拒绝</el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <template v-if="approvalForm.handle.operation_type == 'manual_approval'">
                          <div class="tab_list_wrap">
                              <ul>
                                  <li  :class="{'active':tabActive === 1}" @click="tabActive = 1">审批人设置</li>
                                  <li v-if="approvalType == '' || approvalType == 'order_add' || approvalType == 'order_purchase'" :class="{'active':tabActive === 2}" @click="tabActive = 2">表单权限</li>
                                  <li  :class="{'active':tabActive === 3}" @click="tabActive = 3">操作权限</li>
                              </ul>
                          </div>
                          <template v-if="tabActive == 1">
                              <div class="approval_info_wrap">
                                 <div class="approval_info_title">
                                      <span>审批人</span>
                                 </div>
                                  <el-form-item prop="type">
                                      <el-radio-group   v-model="approvalForm.handle.type">
                                          <el-radio :label="item.value" v-for="item in userTypeList" @change="handleChangeUserType(approvalForm.handle)">{{item.label}}
                                              <el-tooltip class="item" effect="dark" placement="top-start"  v-if="item.value == 'user_tags'">
                                                  <div slot="content">
                                                      如何使用？<br>
                                                      1、在人事管理->人员标签中设置标签，可以将相同审批职能的人设置为同一个标签<br>
                                                      2、用人员标签作为审批人，当有成员离职变动时，该标签中的其他成员可继续完成审批
                                                  </div>
                                                  <i class=" iconfont icon-bangzhuzhongxin"></i>
                                              </el-tooltip>
                                          </el-radio>
                                      </el-radio-group>
                                  </el-form-item>
                                  <!--审批人选择提交人自选-->
                                  <template  v-if="approvalForm.handle.type==='submitter_choice'">
                                      <el-form-item label="添加成员" prop="is_single" class="form_item_border_top label-bold" >
                                            <!--@change="()=>{approvalForm.handle.relate_id=[];approvalForm.handle.relate_ids=[]}"-->
                                          <el-radio-group v-model="approvalForm.handle.is_single" @change="handleChangeIsSingle(approvalForm.handle)">
                                              <el-radio :label="1">单人</el-radio>
                                              <el-radio :label="2">多人</el-radio>
                                          </el-radio-group>
                                      </el-form-item>
                                      <el-form-item label="选择范围" prop="is_all_company" class="form_item_border_top label-bold" >
                                          <el-radio-group  v-model="approvalForm.handle.is_all_company" @change="()=>{approvalForm.handle.relate_id=[];approvalForm.handle.relate_ids=[]}">
                                              <el-radio :label="1">全公司</el-radio>
                                              <el-radio :label="2">指定成员</el-radio>
                                          </el-radio-group>
                                      </el-form-item>
                                      <!-- 选择的  添加成员是单人/多人~ 选择范围是指定成员时-->
                                      <el-form-item :label="approvalForm.handle.is_single ==  1 ? '添加成员' :'添加成员（可多选）'"   prop="assign_users"  class="form_item_border_top label-bold"  v-if="approvalForm.handle.is_all_company == 2">
                                          <ul class="approve_user_list">
                                              <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in approvalForm.handle.relate_id">
                                                  <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                  <span v-text="user.relate_name"></span>
                                                  <i @click="handleDelApproversUsers(userIndex,approvalForm.handle.relate_id,approvalForm.handle.relate_ids)" class="el-icon-error"></i>
                                              </li>
                                                <!--v-if="(approvalForm.handle.is_single == 1 && approvalForm.handle.relate_id.length == 1) ? false : true"-->
                                              <li class="add_approve_btn">
                                                  <el-popover placement="top"  ref="userPopover"  trigger="click">
                                                      <i class="el-icon-plus" slot="reference"></i>
                                                      <el-select :remote-method="getUserList" collapse-tags  filterable value  placeholder="请选择成员"  remote  size="small">
                                                          <el-option :key="user.uid"  :label="user.name"  :value="user.uid"  @click.native="handleSelectApproversUsers(user,approvalForm.handle.relate_id,approvalForm.handle.relate_ids)"  v-for="user in userList">
                                                          </el-option>
                                                      </el-select>
                                                  </el-popover>
                                              </li>
                                          </ul>
                                      </el-form-item>

                                  </template>
                                  <!-- 审批人选择指定成员时-->
                                  <template  v-if="approvalForm.handle.type == 'specified'">
                                      <el-form-item  label="添加成员（可多选）"   prop="approvers_users"  class="form_item_border_top label-bold">
                                          <ul class="approve_user_list">
                                              <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in approvalForm.handle.relate_id">
                                                  <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                  <span v-text="user.relate_name"></span>
                                                  <i @click="handleDelApproversUsers(userIndex,approvalForm.handle.relate_id,approvalForm.handle.relate_ids)" class="el-icon-error"></i>
                                              </li>
                                              <li class="add_approve_btn" >
                                                  <el-popover placement="top"  ref="userPopover"  trigger="click">
                                                      <i class="el-icon-plus" slot="reference"></i>
                                                      <el-select :remote-method="getUserList" collapse-tags  filterable value  placeholder="请选择成员"  remote  size="small">
                                                          <el-option :key="user.uid"  :label="user.name"  :value="user.uid"  @click.native="handleSelectApproversUsers(user,approvalForm.handle.relate_id,approvalForm.handle.relate_ids)"  v-for="user in userList">
                                                          </el-option>
                                                      </el-select>
                                                  </el-popover>
                                              </li>
                                          </ul>
                                      </el-form-item>
                                  </template>
                                  <!-- 审批人选择人员标签时-->
                                  <template v-if="approvalForm.handle.type === 'user_tags'">
                                      <!--人员标签/人员标签-->
                                      <el-form-item prop="role_ids" label="人员标签" class="form_item_border_top label-bold">
                                          <div class="form_item_wrap">
                                              <div class="form_item_name">
                                                  选择人员标签：
                                              </div>
                                              <div class="form_item_value">
                                                  <el-select  filterable multiple placeholder="请选择人员标签"  collapse-tags   v-model="approvalForm.handle.relate_ids" @remove-tag="handleRemoveUserTags($event,approvalForm.handle.relate_id,approvalForm.handle.relate_ids)">
                                                      <el-option :key="role.id" :label="role.name" :value="role.id" @click.native="handleClickUserTags(role,approvalForm.handle.relate_id,approvalForm.handle.relate_ids)" v-for="role in roleList"></el-option>
                                                  </el-select>
                                                  <p class="del_relate_class" v-if="approvalForm.handle.del_relate_id && approvalForm.handle.del_relate_id.length > 0">
                                                      人员标签被删除:
                                                      <span v-text="approvalForm.handle.del_relate_id.map(map => map.relate_name).join(',')"></span>
                                                  </p>
                                              </div>
                                          </div>
                                      </el-form-item>
                                  </template>
                                  <!--连续多级上级-->
                                  <template v-if="approvalForm.handle.type === 'successive_superior'">
                                      <el-form-item prop="successive_superior_value" label="设置审批层级" class="form_item_border_top label-bold">
                                          <p class="quick_tips">设置后，该节点将从直属上级到已选的层级依次审批</p>
                                          <div class="form_item_wrap">
                                              <div class="form_item_name">
                                                  提交人的：
                                              </div>
                                              <div class="form_item_value">
                                                  <el-select    placeholder="请选择" remote v-model="approvalForm.handle.relate_ids_string">
                                                      <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id"  @click.native="handleSelectSuperiorDepartment(level,'approvalForm')" v-for="level in multiLevelSuperiorList"></el-option>
                                                  </el-select>
                                              </div>
                                          </div>
                                      </el-form-item>
                                  </template>
                                  <!--连续多级部门-->
                                  <template v-if="approvalForm.handle.type === 'successive_department'">
                                      <el-form-item prop="successive_department_value" label="设置审批层级" class="form_item_border_top label-bold">
                                          <p class="quick_tips">设置后，该节点将从直属部门负责人到已选层级的部门负责人依次审批</p>
                                          <div class="form_item_wrap">
                                              <div class="form_item_name">
                                                  提交人的：
                                              </div>
                                              <div class="form_item_value">
                                                  <el-select    placeholder="请选择" remote v-model="approvalForm.handle.relate_ids_string">
                                                      <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id" @click.native="handleSelectSuperiorDepartment(level,'approvalForm')" v-for="level in multiLevelDepartmentsList"></el-option>
                                                  </el-select>
                                              </div>
                                          </div>
                                      </el-form-item>
                                  </template>
                              </div>

                              <!--审批人选择 直属上级/部门负责人/人员标签/连续多级上级/连续多级部门-->
                              <template v-if="approvalForm.handle.type == 'superior'||approvalForm.handle.type == 'department_head' || approvalForm.handle.type == 'user_tags' || approvalForm.handle.type == 'successive_superior' || approvalForm.handle.type == 'successive_department'">
                                  <el-form-item label="审批人为空时" prop="is_null_auto" class="form_item_no_padding_left_right label-bold">
                                      <el-radio-group v-model="approvalForm.handle.is_null_auto">
                                          <el-radio :label="1">自动通过</el-radio>
                                          <el-radio :label="2">指定人员办理</el-radio>
                                          <!--<el-radio :label="3">转交给审批管理员</el-radio>-->
                                      </el-radio-group>
                                  </el-form-item>

                                  <el-form-item label="添加成员（可多选）"  prop="null_relate_id"  class="form_item_border_top form_item_no_padding_left_right label-bold" v-if="approvalForm.handle.is_null_auto==2">
                                      <ul class="approve_user_list">
                                          <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in approvalForm.handle.null_relate_id">
                                              <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                              <span v-text="user.relate_name"></span>
                                              <i @click="handleDelApproversUsers(userIndex,approvalForm.handle.null_relate_id)" class="el-icon-error"></i>
                                          </li>
                                          <li class="add_approve_btn" >
                                              <el-popover placement="top"  ref="userPopover"  trigger="click">
                                                  <i class="el-icon-plus" slot="reference"></i>
                                                  <el-select :remote-method="getUserList" collapse-tags  filterable value  placeholder="请选择成员"  remote  size="small">
                                                      <el-option :key="user.uid"  :label="user.name"  :value="user.uid"  @click.native="handleSelectApproversUsers(user,approvalForm.handle.null_relate_id)"  v-for="user in userList">
                                                      </el-option>
                                                  </el-select>
                                              </el-popover>
                                          </li>
                                      </ul>
                                  </el-form-item>

                              </template>
                              <!-- 如果是:-->
                              <!-- 1.审批人选择直属上级 并且 审批人为空时选择指定人员办理;-->
                              <!-- 2.审批人选择部门负责人;-->
                              <!-- 3.审批人选择指定成员;-->
                              <!-- 4.审批人选择人员标签;-->
                              <!-- 5.审批人选择提交人自选 并且  添加成员为多人;-->
                              <!-- 6.审批人选择连续多级部门-->
                              <template v-if="(approvalForm.handle.type == 'superior'&&approvalForm.handle.is_null_auto=='2')
                                            ||approvalForm.handle.type == 'department_head'
                                            ||approvalForm.handle.type == 'specified'
                                            ||approvalForm.handle.type == 'user_tags'
                                            ||(approvalForm.handle.type == 'submitter_choice'&& approvalForm.handle.is_single=='2')">
                                  <el-form-item label="审批人为多人时" prop="approval_mode" class="form_item_no_padding_left_right label-bold">
                                      <el-radio-group v-model="approvalForm.handle.approval_mode">
                                          <el-radio :label="1">会签（需所有审批人同意）</el-radio>
                                          <el-radio :label="2">或签（任意一名审批人同意即可）</el-radio>
                                          <el-radio :label="3">依次审批（按照顺序进行依次审批）</el-radio>
                                      </el-radio-group>
                                  </el-form-item>
                              </template>

                              <!--审批人选择的不是直属上级-->
                              <template  v-if="approvalForm.handle.type !== 'superior'">
                                  <el-form-item label="审批人与提交人为同一人时" prop="consistency_type" class="form_item_no_padding_left_right label-bold">
                                      <el-radio-group v-model="approvalForm.handle.consistency_type">
                                          <el-radio :label="1">自动通过</el-radio>
                                          <el-radio :label="2">提交审批人</el-radio>
                                          <el-radio :label="3">转交给直属上级</el-radio>
                                          <el-radio :label="4" v-if="approvalForm.handle.type !== 'department_head'">转交给提交人的部门负责人审批</el-radio>
                                      </el-radio-group>
                                  </el-form-item>
                              </template>

                              <div class="prompt_text mb_16">
                                  提示：<br>
                                  若审批人离职，自动转让给审批人的上级代为处理。 <br>
                                  若审批人没有直属上级，则转交给超级管理员。 <br>
                                  若同一审批人在流程上多次出现，可通过设置进行更改。
                              </div>

                              <div class="cc_list_wrap mt-15">
                                  <ul>
                                      <li v-for="(item,ccIndex) in approvalForm.cc_info" :key="ccIndex">
                                          <div class="cc_list_title">
                                              <span>抄送人</span>
                                              <span class="handle_icon_wrap" @click="handleClickDelCCInfo('approvalForm',ccIndex)">
                                                  <i class="iconfont icon-shanchu1"></i>
                                              </span>
                                          </div>
                                          <el-form-item prop="type" class="cc_list_radio">
                                              <el-radio-group v-model="item.type" @change="handleChangeCCUserType(item)">
                                                  <el-radio :label="userType.value" :disabled="approvalForm.cc_info.find((find,findIndex) => (find.type == userType.value && findIndex!=ccIndex)) ? true : false" v-for="userType in userTypeList" @change="handleChangeCCUserType(item)">{{userType.label}}
                                                      <el-tooltip class="item" effect="dark" placement="top-start" v-if="userType.value == 'user_tags'">
                                                          <div slot="content">
                                                              如何使用？<br>
                                                              1、在人事管理->人员标签中设置标签，可以将相同职能的人设置为同一个标签<br>
                                                              2、标签中的人员均可收到该审批抄送
                                                          </div>
                                                          <i class=" iconfont icon-bangzhuzhongxin"></i>
                                                      </el-tooltip>
                                                  </el-radio>
                                              </el-radio-group>
                                          </el-form-item>

                                           <!--选择提交人自选-->
                                          <template  v-if="item.type==='submitter_choice'">
                                              <el-form-item label="添加成员" prop="is_single" class="form_item_border_top label-bold" >
                                                    <!--@change="()=>{item.relate_id=[];item.relate_ids=''}"-->
                                                  <el-radio-group v-model="item.is_single"  >
                                                      <el-radio :label="1">单人</el-radio>
                                                      <el-radio :label="2">多人</el-radio>
                                                  </el-radio-group>
                                              </el-form-item>
                                              <el-form-item label="选择范围" prop="is_all_company" class="form_item_border_top label-bold" >
                                                  <el-radio-group  v-model="item.is_all_company" @change="()=>{item.relate_id=[];item.relate_ids=''}">
                                                      <el-radio :label="1">全公司</el-radio>
                                                      <el-radio :label="2">指定成员</el-radio>
                                                  </el-radio-group>
                                              </el-form-item>
                                              <!-- 选择的  添加成员是单人/多人~ 选择范围是指定成员时-->
                                              <el-form-item :label="item.is_single == 1 ? '添加成员（可多选）' :'添加成员（可多选）'"   prop="assign_users"  class="form_item_border_top label-bold"  v-if="item.is_all_company == 2">
                                                  <ul class="approve_user_list">
                                                      <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                                          <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                          <span v-text="user.relate_name"></span>
                                                          <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                                      </li>
                                                      <!-- v-if="(item.is_single == 1 && item.relate_id.length == 1) ? false : true"-->
                                                      <li class="add_approve_btn" >
                                                          <el-popover placement="top"   :ref="'userPopover' + ccIndex"   trigger="click">
                                                              <i class="el-icon-plus" slot="reference"></i>
                                                              <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                              <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                              </el-option>
                                                          </el-select>
                                                          </el-popover>
                                                      </li>
                                                  </ul>
                                              </el-form-item>
                                          </template>

                                          <!--指定成员选择人员-->
                                          <el-form-item prop="cc_users" label="添加成员（可多选）" class="form_item_border_top label-bold" v-if="item.type === 'specified'">
                                              <ul class="approve_user_list">
                                                  <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                                      <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                      <span v-text="user.relate_name"></span>
                                                      <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                                  </li>
                                                  <li class="add_approve_btn">
                                                      <el-popover placement="top"  :ref="'userPopover'+ccIndex"   trigger="click">
                                                          <i class="el-icon-plus" slot="reference"></i>
                                                          <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                              <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                              </el-option>
                                                          </el-select>
                                                      </el-popover>
                                                  </li>
                                              </ul>
                                          </el-form-item>

                                          <!--人员标签/人员标签-->
                                          <el-form-item prop="cc_role_ids" label="人员标签" class="form_item_border_top label-bold" v-if="item.type === 'user_tags'">
                                              <div class="form_item_wrap">
                                                  <div class="form_item_name">
                                                      选择人员标签：
                                                  </div>
                                                  <div class="form_item_value">
                                                      <el-select :key="'cc_role_ids' + ccIndex" filterable multiple placeholder="请选择人员标签" collapse-tags   v-model="item.relate_ids" @remove-tag="handleSelectCCRemoveTags($event,item,ccIndex)">
                                                          <el-option :key="role.id" :label="role.name" :value="role.id" @click.native="handleSelectCCTags(role,item,ccIndex)"  v-for="role in roleList"></el-option>
                                                      </el-select>
                                                      <p class="del_relate_class" v-if="item.del_relate_id && item.del_relate_id.length > 0">
                                                          人员标签被删除:
                                                          <span v-text="item.del_relate_id.map(map => map.relate_name).join(',')"></span>
                                                      </p>
                                                  </div>
                                               </div>
                                          </el-form-item>

                                          <!--连续多级上级-->
                                          <el-form-item prop="successive_superior" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_superior'">
                                              <p class="quick_tips">设置后，该节点将从直属上级到已选的层级依次审批</p>
                                              <div class="form_item_wrap">
                                                  <div class="form_item_name">
                                                      提交人的：
                                                  </div>
                                                  <div class="form_item_value">
                                                      <el-select :key="'successive_superior' + ccIndex"  placeholder="请选择" remote v-model="item.relate_ids_string">
                                                          <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id"  @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)"  v-for="level in multiLevelSuperiorList"></el-option>
                                                      </el-select>
                                                  </div>
                                              </div>
                                          </el-form-item>

                                          <!--连续多级部门-->
                                          <el-form-item prop="successive_department" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_department'">
                                              <p class="quick_tips">设置后，该节点将从直属部门负责人到已选层级的部门负责人依次审批</p>
                                              <div class="form_item_wrap">
                                                  <div class="form_item_name">
                                                      提交人的：
                                                  </div>
                                                  <div class="form_item_value">
                                                      <el-select  :key="'successive_department' + ccIndex" placeholder="请选择" remote v-model="item.relate_ids_string">
                                                          <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id" @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)" v-for="level in multiLevelDepartmentsList"></el-option>
                                                      </el-select>
                                                  </div>
                                              </div>
                                          </el-form-item>

                                      </li>
                                  </ul>
                              </div>
                              <div>
                                  <el-button type="text" v-if="approvalForm.cc_info.length<8"  @click="handleClickAddCCInfo('approvalForm')"><i class="el-icon-plus"></i>添加抄送人</el-button>
                              </div>
                          </template>
                          <template v-if="tabActive == 2">
                              <div class="permissions_form">
                                  <ul>
                                      <li class="permissions_form_top">
                                          <div class="field_name">表单字段</div>
                                          <div class="field_read_only" @click="handleClickFieldAuth(1)"><el-radio v-model="permissions_form_radio" :label="1">只读</el-radio></div>
                                          <div class="field_editable" @click="handleClickFieldAuth(2)"><el-radio v-model="permissions_form_radio" :label="2">可编辑</el-radio></div>
                                          <div class="field_hide" @click="handleClickFieldAuth(3)"><el-radio  v-model="permissions_form_radio" :label="3">隐藏</el-radio></div>
                                      </li>
                                      <li v-for="item in field_auth">
                                          <div class="field_name" v-text="fieldAuthList.find(find => find.field_key == item.field_key) ? fieldAuthList.find(find => find.field_key == item.field_key).field_name :''"></div>
                                          <div class="field_read_only"><el-radio v-model="item.field_auth" :label="1">只读</el-radio></div>
                                          <div class="field_editable"><el-radio v-model="item.field_auth" :label="2">可编辑</el-radio></div>
                                          <div class="field_hide"><el-radio v-model="item.field_auth" :label="3">隐藏</el-radio></div>
                                      </li>

                                  </ul>
                              </div>
                          </template>
                          <template v-if="tabActive == 3">
                              <el-form-item prop="allow_transfer">
                                  <el-checkbox :false-label="0" :true-label="1" v-model="approvalForm.allow_transfer">允许转交</el-checkbox>
                                  <br>
                                  <el-checkbox :false-label="0" :true-label="1" v-model="approvalForm.allow_add_signature">允许加/减签</el-checkbox>
                                  <br>
                                  <el-checkbox :false-label="0" :true-label="1" v-model="approvalForm.allow_return">允许回退</el-checkbox>
                              </el-form-item>
                          </template>
                      </template>
                      <template v-else>
                          <el-form-item prop="reason" label="原因">
                             <el-input type="textarea" :rows="4" placeholder="请输入原因" v-model="approvalForm.handle.reason"></el-input>
                          </el-form-item>
                      </template>
                  </div>
              </el-form>
          </template>

          <template v-if="approvalProcessType == 'conduct'">
              <el-form :model="conductForm"  label-position="top" ref="conductForm"   size="small" class="approval_process_form">
                  <div class="approval_process_title">
                      <div  class="approval_process_title_edit" :class="conductForm.is_edit ? 'width_flex_1' : ''">
                          <span v-if="!conductForm.is_edit" v-text="conductForm.name"></span>
                          <span class="handle_icon_wrap"  v-if="!conductForm.is_edit" @click="handleClickEditTitle(conductForm)">
                              <i  class="iconfont icon-bianji" ></i>
                          </span>
                          <el-input @blur="handleTitleBlur($event,conductForm)"
                                    @keyup.enter.native="handleTitleBlur($event,conductForm)"
                                    clearable
                                    maxlength="10"
                                    placeholder="请输入标题"
                                    ref="titleInput"
                                    size="small"
                                    v-if="conductForm.is_edit"
                                    v-model="conductForm.name">
                          </el-input>
                      </div>
                  </div>

                  <div class="approval_process_form_wrap">
                      <div class="tab_list_wrap">
                          <ul>
                              <li  :class="{'active':tabActive === 1}" @click="tabActive = 1">办理人设置</li>
                              <li v-if="approvalType == '' || approvalType == 'order_add' || approvalType == 'order_purchase'" :class="{'active':tabActive === 2}" @click="tabActive = 2">表单权限</li>
                              <li  :class="{'active':tabActive === 3}" @click="tabActive = 3">操作权限</li>
                          </ul>
                      </div>
                      <template v-if="tabActive == 1">
                          <div class="approval_info_wrap">
                              <div class="approval_info_title">
                                  <span>办理人</span>
                              </div>
                              <el-form-item prop="type">
                                  <el-radio-group   v-model="conductForm.handle.type">
                                      <el-radio :label="item.value" v-for="item in userTypeList" @change="handleChangeUserType(conductForm.handle)">{{item.label}}
                                          <el-tooltip class="item" effect="dark" placement="top-start"  v-if="item.value == 'user_tags'">
                                              <div slot="content">
                                                  如何使用？<br>
                                                  1、在人事管理->人员标签中设置标签，可以将相同办理职能的人设置为同一个标签<br>
                                                  2、用人员标签作办理人，当有成员离职变动时，该标签中的其他成员可继续完成办理
                                              </div>
                                              <i class=" iconfont icon-bangzhuzhongxin"></i>
                                          </el-tooltip>
                                      </el-radio>
                                  </el-radio-group>
                              </el-form-item>
                              <!--办理人选择提交人自选-->
                              <template  v-if="conductForm.handle.type==='submitter_choice'">
                                  <el-form-item label="添加成员" prop="is_single" class="form_item_border_top" >
                                      <el-radio-group v-model="conductForm.handle.is_single"  @change="handleChangeIsSingle(conductForm.handle)">
                                          <el-radio :label="1">单人</el-radio>
                                          <el-radio :label="2">多人</el-radio>
                                      </el-radio-group>
                                  </el-form-item>
                                  <el-form-item label="选择范围" prop="is_all_company" class="form_item_border_top">
                                      <el-radio-group  v-model="conductForm.handle.is_all_company">
                                          <el-radio :label="1">全公司</el-radio>
                                          <el-radio :label="2">指定成员</el-radio>
                                      </el-radio-group>
                                  </el-form-item>

                                  <!-- 选择的  添加成员是单人/多人~ 选择范围是指定成员时-->
                                  <el-form-item :label="conductForm.handle.is_single == 1 ? '添加成员（可多选）' :'添加成员（可多选）'"   prop="assign_users"  class="form_item_border_top label-bold"  v-if="conductForm.handle.is_all_company == 2">
                                      <ul class="approve_user_list">
                                          <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in conductForm.handle.relate_id">
                                              <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                              <span v-text="user.relate_name"></span>
                                              <i @click="handleDelApproversUsers(userIndex,conductForm.handle.relate_id,conductForm.handle.relate_ids)" class="el-icon-error"></i>
                                          </li>
                                          <!--v-if="(conductForm.handle.is_single == '1' && conductForm.handle.relate_id.length == 1) ? false : true"-->
                                          <li class="add_approve_btn" >
                                              <el-popover placement="top"  ref="userPopover"  trigger="click">
                                                  <i class="el-icon-plus" slot="reference"></i>
                                                  <el-select :remote-method="getUserList" collapse-tags  filterable value  placeholder="请选择成员"  remote  size="small">
                                                      <el-option :key="user.uid"  :label="user.name"  :value="user.uid"  @click.native="handleSelectApproversUsers(user,conductForm.handle.relate_id,conductForm.handle.relate_ids)"  v-for="user in userList">
                                                      </el-option>
                                                  </el-select>
                                              </el-popover>
                                          </li>
                                      </ul>
                                  </el-form-item>
                              </template>

                              <!-- 办理人选择指定成员时-->
                              <template  v-if="conductForm.handle.type == 'specified'">
                                  <el-form-item  label="添加成员（可多选）"   prop="processors_users"  class="form_item_border_top label-bold">
                                      <ul class="approve_user_list">
                                          <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in conductForm.handle.relate_id">
                                              <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                              <span v-text="user.relate_name"></span>
                                              <i @click="handleDelApproversUsers(userIndex,conductForm.handle.relate_id,conductForm.handle.relate_ids)" class="el-icon-error"></i>
                                          </li>
                                          <li class="add_approve_btn" >
                                              <el-popover placement="top"  ref="userPopover"  trigger="click">
                                                  <i class="el-icon-plus" slot="reference"></i>
                                                  <el-select :remote-method="getUserList" collapse-tags  filterable value  placeholder="请选择成员"  remote  size="small">
                                                      <el-option :key="user.uid"  :label="user.name"  :value="user.uid"  @click.native="handleSelectApproversUsers(user,conductForm.handle.relate_id,conductForm.handle.relate_ids)"  v-for="user in userList">
                                                      </el-option>
                                                  </el-select>
                                              </el-popover>
                                          </li>
                                      </ul>
                                  </el-form-item>
                              </template>
                              <!-- 办理人选择人员标签时-->
                              <template v-if="conductForm.handle.type === 'user_tags'">
                                  <el-form-item prop="role_ids" label="人员标签" class="form_item_border_top label-bold">
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              选择人员标签：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select  filterable multiple placeholder="请选择人员标签" collapse-tags  v-model="conductForm.handle.relate_ids" @remove-tag="handleRemoveUserTags($event,conductForm.handle.relate_id,conductForm.handle.relate_ids)">
                                                  <el-option :key="role.id" :label="role.name" :value="role.id" @click.native="handleClickUserTags(role,conductForm.handle.relate_id,conductForm.handle.relate_ids)" v-for="role in roleList"></el-option>
                                              </el-select>
                                              <p class="del_relate_class" v-if="conductForm.handle.del_relate_id && conductForm.handle.del_relate_id.length > 0">
                                                  人员标签被删除:
                                                  <span v-text="conductForm.handle.del_relate_id.map(map => map.relate_name).join(',')"></span>
                                              </p>
                                          </div>
                                      </div>
                                  </el-form-item>
                              </template>

                              <!--办理人选连续多级上级-->
                              <template v-if="conductForm.handle.type === 'successive_superior'">
                                  <el-form-item prop="successive_superior_value" label="设置审批层级" class="form_item_border_top label-bold">
                                      <p class="quick_tips">设置后，该节点将从直属上级到已选的层级依次办理</p>
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              提交人的：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select    placeholder="请选择" remote v-model="conductForm.handle.relate_ids_string">
                                                  <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id" @click.native="handleSelectSuperiorDepartment(level,'conductForm')" v-for="level in multiLevelSuperiorList"></el-option>
                                              </el-select>
                                          </div>
                                      </div>
                                  </el-form-item>
                              </template>
                              <!--办理人选连续多级部门-->
                              <template v-if="conductForm.handle.type === 'successive_department'">
                                  <el-form-item prop="successive_department_value" label="设置审批层级" class="form_item_border_top label-bold">
                                      <p class="quick_tips">设置后，该节点将从直属部门负责人到已选层级的部门负责人依次办理</p>
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              提交人的：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select    placeholder="请选择" remote v-model="conductForm.handle.relate_ids_string">
                                                  <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id" @click.native="handleSelectSuperiorDepartment(level,'conductForm')" v-for="level in multiLevelDepartmentsList"></el-option>
                                              </el-select>
                                          </div>
                                      </div>
                                  </el-form-item>
                              </template>
                          </div>

                          <!-- 如果是:-->
                          <!-- 1.办理人选择直属上级 并且 办理人为空时选择指定人员办理;-->
                          <!-- 2.办理人选择部门负责人;-->
                          <!-- 3.办理人选择指定成员;-->
                          <!-- 4.办理人选择人员标签;-->
                          <!-- 5.办理人选择提交人自选 并且  添加成员为多人;-->
                          <template v-if="(conductForm.handle.type == 'superior'&&conductForm.handle.is_null_auto=='2')
                                            ||conductForm.handle.type == 'department_head'
                                            ||conductForm.handle.type == 'specified'
                                            ||conductForm.handle.type == 'user_tags'
                                            ||(conductForm.handle.type == 'submitter_choice'&& conductForm.handle.is_single==2)">
                              <el-form-item label="办理人为多人时" prop="approval_mode" class="form_item_no_padding_left_right label-bold">
                                  <el-radio-group v-model="conductForm.handle.approval_mode">
                                      <el-radio :label="1">会签（需所有办理人同意）</el-radio>
                                      <el-radio :label="2">或签（任意一名办理人同意即可）</el-radio>
                                  </el-radio-group>
                              </el-form-item>
                          </template>

                          <!--办理人选择 直属上级/部门负责人/人员标签/连续多级上级/连续多级部门-->
                          <template v-if="conductForm.handle.type == 'superior'||conductForm.handle.type == 'department_head' || conductForm.handle.type == 'user_tags' || conductForm.handle.type == 'successive_superior' || conductForm.handle.type == 'successive_department'">
                              <el-form-item label="办理人为空时" prop="is_null_auto" class="form_item_no_padding_left_right label-bold">
                                  <el-radio-group v-model="conductForm.handle.is_null_auto">
                                      <el-radio :label="2">指定人员办理</el-radio>
                                     <!--<el-radio :label="3">转交给审批管理员</el-radio>-->
                                  </el-radio-group>
                              </el-form-item>

                              <el-form-item label="添加成员（可多选）"  prop="null_users"  class=" form_item_no_padding_left_right label-bold" v-if="conductForm.handle.is_null_auto==2">
                                  <ul class="approve_user_list">
                                      <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in conductForm.handle.null_relate_id">
                                          <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                          <span v-text="user.relate_name"></span>
                                          <i @click="handleDelApproversUsers(userIndex,conductForm.handle.null_relate_id)" class="el-icon-error"></i>
                                      </li>
                                      <li class="add_approve_btn" >
                                          <el-popover placement="top"  ref="userPopover"  trigger="click">
                                              <i class="el-icon-plus" slot="reference"></i>
                                              <el-select :remote-method="getUserList" collapse-tags  filterable value  placeholder="请选择成员"  remote  size="small">
                                                  <el-option :key="user.uid"  :label="user.name"  :value="user.uid"  @click.native="handleSelectApproversUsers(user,conductForm.handle.null_relate_id)"  v-for="user in userList">
                                                  </el-option>
                                              </el-select>
                                          </el-popover>
                                      </li>
                                  </ul>
                              </el-form-item>


                          </template>


                          <div class="prompt_text mb_16">
                              提示：<br>
                              若办理人离职，自动转交给办理人的上级代为处理。<br>
                              若办理人没有直属上级，则转交给超级管理员。<br>
                              办理人不可跳过。
                          </div>

                           <div class="cc_list_wrap mt-15">
                                  <ul>
                                      <li v-for="(item,ccIndex) in conductForm.cc_info" :key="ccIndex">
                                          <div class="cc_list_title">
                                              <span>抄送人</span>
                                              <span class="handle_icon_wrap" @click="handleClickDelCCInfo('conductForm',ccIndex)">
                                                  <i class="iconfont icon-shanchu1"></i>
                                              </span>
                                          </div>
                                          <el-form-item prop="type" class="cc_list_radio">
                                              <el-radio-group v-model="item.type" @change="handleChangeCCUserType(item)">
                                                  <el-radio :label="userType.value" :disabled="conductForm.cc_info.find((find,findIndex) => (find.type == userType.value && findIndex!=ccIndex)) ? true : false" v-for="userType in userTypeList" @change="handleChangeCCUserType(item)">{{userType.label}}
                                                      <el-tooltip class="item" effect="dark" placement="top-start" v-if="userType.value == 'user_tags'">
                                                          <div slot="content">
                                                              如何使用？<br>
                                                              1、在人事管理->人员标签中设置标签，可以将相同职能的人设置为同一个标签<br>
                                                              2、标签中的人员均可收到该审批抄送
                                                          </div>
                                                          <i class=" iconfont icon-bangzhuzhongxin"></i>
                                                      </el-tooltip>
                                                  </el-radio>
                                              </el-radio-group>
                                          </el-form-item>

                                           <!--选择提交人自选-->
                                          <template  v-if="item.type==='submitter_choice'">
                                              <el-form-item label="添加成员" prop="is_single" class="form_item_border_top label-bold" >
                                                    <!-- @change="()=>{item.relate_id=[];item.relate_ids=''}"-->
                                                  <el-radio-group v-model="item.is_single" >
                                                      <el-radio :label="1">单人</el-radio>
                                                      <el-radio :label="2">多人</el-radio>
                                                  </el-radio-group>
                                              </el-form-item>
                                              <el-form-item label="选择范围" prop="is_all_company" class="form_item_border_top label-bold" >
                                                  <el-radio-group  v-model="item.is_all_company" @change="()=>{item.relate_id=[];item.relate_ids=''}">
                                                      <el-radio :label="1">全公司</el-radio>
                                                      <el-radio :label="2">指定成员</el-radio>
                                                  </el-radio-group>
                                              </el-form-item>
                                              <!-- 选择的  添加成员是单人/多人~ 选择范围是指定成员时-->
                                              <el-form-item :label="item.is_single == 1 ? '添加成员（可多选）' :'添加成员（可多选）'"   prop="assign_users"  class="form_item_border_top label-bold"  v-if="item.is_all_company == 2">
                                                  <ul class="approve_user_list">
                                                      <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                                          <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                          <span v-text="user.relate_name"></span>
                                                          <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                                      </li>
                                                        <!--v-if="(item.is_single == 1 && item.relate_id.length == 1) ? false : true"-->
                                                      <li class="add_approve_btn" >
                                                          <el-popover placement="top"   :ref="'userPopover' + ccIndex"  trigger="click">
                                                              <i class="el-icon-plus" slot="reference"></i>
                                                              <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                              <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                              </el-option>
                                                          </el-select>
                                                          </el-popover>
                                                      </li>
                                                  </ul>
                                              </el-form-item>
                                          </template>

                                          <!--指定成员选择人员-->
                                          <el-form-item prop="cc_users" label="添加成员（可多选）" class="form_item_border_top label-bold" v-if="item.type === 'specified'">
                                              <ul class="approve_user_list">
                                                  <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                                      <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                      <span v-text="user.relate_name"></span>
                                                      <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                                  </li>
                                                  <li class="add_approve_btn">
                                                      <el-popover placement="top"  :ref="'userPopover'+ccIndex"   trigger="click">
                                                          <i class="el-icon-plus" slot="reference"></i>
                                                          <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                              <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                              </el-option>
                                                          </el-select>
                                                      </el-popover>
                                                  </li>
                                              </ul>
                                          </el-form-item>

                                          <!--人员标签/人员标签-->
                                          <el-form-item prop="cc_role_ids" label="人员标签" class="form_item_border_top label-bold" v-if="item.type === 'user_tags'">
                                              <div class="form_item_wrap">
                                                  <div class="form_item_name">
                                                      选择人员标签：
                                                  </div>
                                                  <div class="form_item_value">
                                                      <el-select :key="'cc_role_ids' + ccIndex" filterable multiple placeholder="请选择人员标签"  collapse-tags  v-model="item.relate_ids" @remove-tag="handleSelectCCRemoveTags($event,item,ccIndex)">
                                                          <el-option :key="role.id" :label="role.name" :value="role.id" @click.native="handleSelectCCTags(role,item,ccIndex)"  v-for="role in roleList"></el-option>
                                                      </el-select>
                                                      <p class="del_relate_class" v-if="item.del_relate_id && item.del_relate_id.length > 0">
                                                          人员标签被删除:
                                                          <span v-text="item.del_relate_id.map(map => map.relate_name).join(',')"></span>
                                                      </p>
                                                  </div>
                                               </div>
                                          </el-form-item>

                                          <!--连续多级上级-->
                                          <el-form-item prop="successive_superior" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_superior'">
                                              <p class="quick_tips">设置后，该节点将从直属上级到已选的层级依次审批</p>
                                              <div class="form_item_wrap">
                                                  <div class="form_item_name">
                                                      提交人的：
                                                  </div>
                                                  <div class="form_item_value">
                                                      <el-select :key="'successive_superior' + ccIndex"  placeholder="请选择" remote v-model="item.relate_ids_string">
                                                          <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id"  @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)"  v-for="level in multiLevelSuperiorList"></el-option>
                                                      </el-select>
                                                  </div>
                                              </div>
                                          </el-form-item>

                                          <!--连续多级部门-->
                                          <el-form-item prop="successive_department" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_department'">
                                              <p class="quick_tips">设置后，该节点将从直属部门负责人到已选层级的部门负责人依次审批</p>
                                              <div class="form_item_wrap">
                                                  <div class="form_item_name">
                                                      提交人的：
                                                  </div>
                                                  <div class="form_item_value">
                                                      <el-select  :key="'successive_department' + ccIndex" placeholder="请选择" remote v-model="item.relate_ids_string">
                                                          <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id" @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)" v-for="level in multiLevelDepartmentsList"></el-option>
                                                      </el-select>
                                                  </div>
                                              </div>
                                          </el-form-item>

                                      </li>
                                  </ul>
                              </div>
                          <div>
                              <el-button type="text" v-if="conductForm.cc_info.length<8"  @click="handleClickAddCCInfo('conductForm')"><i class="el-icon-plus"></i>添加抄送人</el-button>
                          </div>
                      </template>
                      <template v-if="tabActive == 2">
                          <div class="permissions_form">
                              <ul>
                                  <li class="permissions_form_top">
                                      <div class="field_name">表单字段</div>
                                      <div class="field_read_only" @click="handleClickFieldAuth(1)"><el-radio v-model="permissions_form_radio" :label="1">只读</el-radio></div>
                                      <div class="field_editable" @click="handleClickFieldAuth(2)"><el-radio v-model="permissions_form_radio" :label="2">可编辑</el-radio></div>
                                      <div class="field_hide" @click="handleClickFieldAuth(3)"><el-radio  v-model="permissions_form_radio" :label="3">隐藏</el-radio></div>
                                  </li>
                                  <li v-for="item in field_auth">
                                      <div class="field_name" v-text="fieldAuthList.find(find => find.field_key == item.field_key) ? fieldAuthList.find(find => find.field_key == item.field_key).field_name :''"></div>
                                      <div class="field_read_only"><el-radio v-model="item.field_auth" :label="1">只读</el-radio></div>
                                      <div class="field_editable"><el-radio v-model="item.field_auth" :label="2">可编辑</el-radio></div>
                                      <div class="field_hide"><el-radio v-model="item.field_auth" :label="3">隐藏</el-radio></div>
                                  </li>

                              </ul>
                          </div>
                      </template>
                      <template v-if="tabActive == 3">
                          <el-form-item prop="allow_transfer">
                              <el-checkbox :false-label="0" :true-label="1" v-model="conductForm.allow_transfer">允许转交</el-checkbox>
                              <br>
                              <el-checkbox :false-label="0" :true-label="1" v-model="conductForm.allow_add_signature">允许加/减签</el-checkbox>
                              <br>
                              <el-checkbox :false-label="0" :true-label="1" v-model="conductForm.allow_return">允许回退</el-checkbox>
                          </el-form-item>
                      </template>
                  </div>
              </el-form>
          </template>

          <template v-if="approvalProcessType == 'condition'">
              <div class="approval_process_form">
                  <div class="approval_process_title">
                      <div class="approval_process_title_edit" :class="conditionProcessForm.is_edit ? 'width_flex_1' : ''">
                          <span v-if="!conditionProcessForm.is_edit" v-text="conditionProcessForm.name"></span>
                          <span v-if="!conditionProcessForm.is_edit && conditionProcessForm.name !='默认条件'" @click="handleClickEditTitle(conditionProcessForm)" class="handle_icon_wrap">
                              <i  class="iconfont icon-bianji" ></i>
                          </span>
                          <el-input @blur="handleTitleBlur($event,conditionProcessForm)"
                                    @keyup.enter.native="handleTitleBlur($event,conditionProcessForm)"
                                    clearable
                                    maxlength="10"
                                    placeholder="请输入标题"
                                    ref="titleInput"
                                    size="small"
                                    v-if="conditionProcessForm.is_edit"
                                    v-model="conditionProcessForm.name">
                          </el-input>
                      </div>
                      <div v-if="conditionProcessForm.name !='默认条件'">
                          <el-dropdown @command="handleConditionPriority">
                          <span class="el-dropdown-link">
                            优先级{{conditionProcessForm.sort + 1}}<i  class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                              <el-dropdown-menu slot="dropdown">
                                  <el-dropdown-item :command="item" v-for="item in conditionLength">
                                      优先级{{item}}
                                  </el-dropdown-item>
                              </el-dropdown-menu>
                          </el-dropdown>
                      </div>
                  </div>
                  <div class="approval_process_form_wrap">
                      <div class="condition_top_wrap">
                          <div class="condition_title">
                              <span>符合以下条件时进入当前分支</span>
                              <el-tooltip v-if="approvalType != 'order_after_sale'" class="item" content="若想使用金额、数字、单选、时长等控件作为条件请先在表单设计中添加" effect="dark" placement="top-start">
                                  <i class="el-icon-warning"></i>
                              </el-tooltip>
                          </div>
                      </div>
                      <div class="condition_bottom_wrap">
                          <ul>
                              <template  v-for="(item,index) in conditionProcessForm.rules">
                                  <li>
                                      <div class="condition_group_title">
                                          <span >条件组</span>
                                          <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDelConditionGroup(index)">
                                              <i  class="el-icon-close"></i>
                                          </span>
                                      </div>
                                      <div class="condition_list">
                                          <ul>
                                              <li v-for="(child,childIndex) in item" :key="childIndex">
                                                  <div class="condition_item_title_wrap">
                                                      <span v-text="childIndex>0?'且':'当'"></span>
                                                      <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDelCondition(childIndex,item,index)">
                                                         <i  class="iconfont icon-shanchu1"></i>
                                                     </span>
                                                  </div>

                                                  <el-form :model="child" :ref="'group'+index+'ConditionForm'+childIndex" size="small">
                                                      <el-form-item prop="field_key">
                                                          <el-select   placeholder="请选择作为条件的控件"  v-model="child.field_key"   @change="handleSelectConditionFieldChange($event,child)">
                                                              <el-option :key="field.field_key" :label="field.field_name" :value="field.field_key"  v-for="field in conditionFieldList">
                                                              </el-option>
                                                          </el-select>
                                                      </el-form-item>
                                                      <el-form-item prop="operator">
                                                          <el-select placeholder="请选择条件" v-model="child.operator">
                                                              <el-option :label="operator.label" :value="operator.value"  v-for="operator in getOperatorSelectList(child)">
                                                              </el-option>
                                                          </el-select>
                                                      </el-form-item>
                                                      <el-form-item prop="field_value" v-if="conditionFieldList[child.field_key]">
                                                          <template  v-if="conditionFieldList[child.field_key].condition_type==='promoter'">
                                                              <div>
                                                                  <el-select :popper-append-to-body="false"
                                                                             @clear="handleClickClearPromoter(child)"
                                                                             @focus="handleClickPromoter(child)"
                                                                             @remove-tag="handleClickRemovePromoter($event,child)"
                                                                             clearable collapse-tags key="selectPromoter"
                                                                             multiple placeholder="请选择指标"
                                                                             popper-class="selectPopperHideClass"
                                                                             ref="selectPromoter"
                                                                             v-model.trim="child.field_value.ids">
                                                                       <el-option v-for="item in child.field_value.values" :value="item.relate_type_id" :label="item.relate_name" ></el-option>
                                                                  </el-select>
                                                              </div>
                                                          </template>
                                                            <!--选择-->
                                                          <template v-else-if="conditionFieldList[child.field_key].condition_type==='options'">
                                                              <!--请假类型-->
                                                              <el-select v-if="conditionFieldList[child.field_key].field_key==='rest_holiday_rule_id'"  :multiple="conditionFieldList[child.field_key].field_type==='checkbox'"  @change="handleCheckBoxCheckChange(child,conditionFieldList[child.field_key])"  placeholder="请选择指标"   v-model="child.field_value.value">
                                                                  <el-option  :label="radio.label"  :value="radio.value"  v-for="radio in holidayRules"> </el-option>
                                                              </el-select>
                                                              <el-select v-else :multiple="conditionFieldList[child.field_key].field_type==='checkbox' || conditionFieldList[child.field_key].field_type==='order_after_sale' "  @change="handleCheckBoxCheckChange(child,conditionFieldList[child.field_key])" placeholder="请选择指标" v-model="child.field_value.value">
                                                                  <el-option :label="radio.label"  :value="radio.value"   v-for="radio in conditionFieldList[child.field_key].extend.options"></el-option>
                                                              </el-select>
                                                          </template>
                                                          <!--数字-->
                                                          <template  v-else-if="conditionFieldList[child.field_key].condition_type==='number'">
                                                              <el-input-number :precision="2"  controls-position="right"  placeholder="请输入指标"    v-model="child.field_value">
                                                              </el-input-number>
                                                          </template>
                                                          <!--日期-->
                                                          <template v-else-if="conditionFieldList[child.field_key].condition_type==='date'">
                                                              <el-select placeholder="请选择指标"  v-model="child.field_value.value">
                                                                  <el-option label="表单提交时间" value="1"></el-option>
                                                                  <el-option label="自主选择时间" value="2"></el-option>
                                                              </el-select>
                                                              <!--选择自主选择时间-->
                                                              <template v-if="child.field_value.value==='2'">
                                                                  <el-time-picker
                                                                          v-model="child.field_value.date"
                                                                          v-if="conditionFieldList[child.field_key].extend.date_type==='time'"
                                                                          format="HH:mm"
                                                                          value-format="HH:mm"
                                                                          style="margin-top: 12px"
                                                                          placeholder="请选择指标">
                                                                  </el-time-picker>
                                                                  <el-date-picker
                                                                          :format="conditionFieldList[child.field_key].extend.date_type==='date'?'yyyy-MM-dd':conditionFieldList[child.field_key].extend.date_type==='month'?'yyyy-MM':conditionFieldList[child.field_key].extend.date_type==='datetime'?'yyyy-MM-dd HH:mm' : ''"
                                                                          :type="conditionFieldList[child.field_key].extend.date_type"
                                                                          :value-format="conditionFieldList[child.field_key].extend.date_type==='date'?'yyyy-MM-dd':conditionFieldList[child.field_key].extend.date_type==='month'?'yyyy-MM':conditionFieldList[child.field_key].extend.date_type==='datetime'?'yyyy-MM-dd HH:mm' : ''"
                                                                          placeholder="请选择指标"
                                                                          style="margin-top: 12px"
                                                                          v-if="conditionFieldList[child.field_key].extend.date_type!='time'"
                                                                          v-model="child.field_value.date">
                                                                  </el-date-picker>
                                                              </template>

                                                          </template>
                                                          <!--部门-->
                                                          <template v-else-if="conditionFieldList[child.field_key].condition_type==='department'">
                                                              <el-select :popper-append-to-body="true"
                                                                         @clear="handleClickClearDepartment(child,index+ '_' +childIndex)"
                                                                         @focus="handleDepartmentFocus(child,index+ '_' +childIndex)"
                                                                         @remove-tag="handleClickRemoveDepartment($event,child,index+ '_' +childIndex)"
                                                                         clearable
                                                                         collapse-tags
                                                                         multiple
                                                                         placeholder="请选择指标"
                                                                         v-model.trim="child.field_value.titles">
                                                                  <el-option :value="[]" style="height: auto;padding: 0">
                                                                      <el-tree :data="departmentList"
                                                                               :expand-on-click-node='false'
                                                                               :props="{children: 'children',label: 'relate_name'}"
                                                                               :ref="'department' + index + '_' + childIndex"
                                                                               @check-change="(data,checked,indeterminate)=>handleDepartmentCheckChange(data,checked,indeterminate,child)"
                                                                               check-on-click-node
                                                                               check-strictly
                                                                               default-expand-all
                                                                               highlight-current
                                                                               node-key="relate_id"
                                                                               show-checkbox
                                                                               size="mini">
                                                                      </el-tree>
                                                                  </el-option>
                                                              </el-select>
                                                          </template>


                                                      </el-form-item>

                                                  </el-form>
                                              </li>
                                          </ul>
                                          <el-button v-if="approvalType != 'order_after_sale'" @click="handleClickAddCondition(item)" icon="el-icon-plus" type="text">添加条件
                                          </el-button>
                                      </div>
                                  </li>
                                  <div class="either" v-if="index != conditionProcessForm.rules.length-1 && approvalType != 'order_after_sale'">或</div>
                              </template>

                          </ul>
                          <el-button v-if=" approvalType == 'order_after_sale' && conditionProcessForm.rules.length > 0 ? false : true" @click="handleClickAddConditionGroup" icon="el-icon-plus"  type="text">添加条件组</el-button>
                      </div>
                  </div>
              </div>
          </template>

          <template v-if="approvalProcessType == 'end'">
              <el-form :model="endProcessForm"  label-position="top" ref="endProcessForm"   size="small" class="approval_process_form">
                  <div class="approval_process_title">结束</div>
                  <div class="approval_process_form_wrap">

                      <div class="cc_list_wrap">
                            <ul>
                              <li v-for="(item,ccIndex) in endProcessForm.cc_info" :key="ccIndex">
                                  <div class="cc_list_title">
                                      <span>抄送人</span>
                                      <span class="handle_icon_wrap" @click="handleClickDelCCInfo('endProcessForm',ccIndex)">
                                      <i class="iconfont icon-shanchu1"></i>
                                  </span>
                                  </div>
                                  <el-form-item prop="type" class="cc_list_radio">
                                      <el-radio-group v-model="item.type">
                                          <el-radio v-for="userType in userTypeList" :label="userType.value" :disabled="endProcessForm.cc_info.find((find,findIndex) => (find.type == userType.value && findIndex!=ccIndex)) ? true : false"  @change="handleChangeCCUserType(item)">{{userType.label}}
                                              <el-tooltip class="item" effect="dark" placement="top-start" v-if="userType.value == 'user_tags'">
                                                  <div slot="content">
                                                      如何使用？<br>
                                                      1、在人事管理->人员标签中设置标签，可以将相同职能的人设置为同一个标签<br>
                                                      2、标签中的人员均可收到该审批抄送
                                                  </div>
                                                  <i class=" iconfont icon-bangzhuzhongxin"></i>
                                              </el-tooltip>
                                          </el-radio>
                                      </el-radio-group>
                                  </el-form-item>

                                   <!--选择提交人自选-->
                                  <template  v-if="item.type==='submitter_choice'">
                                      <el-form-item label="添加成员" prop="is_single" class="form_item_border_top label-bold" >
                                            <!--@change="()=>{item.relate_id=[];item.relate_ids=''}"-->
                                          <el-radio-group v-model="item.is_single"  >
                                              <el-radio :label="1">单人</el-radio>
                                              <el-radio :label="2">多人</el-radio>
                                          </el-radio-group>
                                      </el-form-item>
                                      <el-form-item label="选择范围" prop="is_all_company" class="form_item_border_top label-bold" >
                                          <el-radio-group  v-model="item.is_all_company" @change="()=>{item.relate_id=[];item.relate_ids=''}">
                                              <el-radio :label="1">全公司</el-radio>
                                              <el-radio :label="2">指定成员</el-radio>
                                          </el-radio-group>
                                      </el-form-item>
                                      <!-- 选择的  添加成员是单人/多人~ 选择范围是指定成员时-->
                                      <el-form-item :label="item.is_single == 1 ? '添加成员（可多选）' :'添加成员（可多选）'"   prop="assign_users"  class="form_item_border_top label-bold"  v-if="item.is_all_company == 2">
                                          <ul class="approve_user_list">
                                              <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                                  <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                                  <span v-text="user.relate_name"></span>
                                                  <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                              </li>
                                                <!-- v-if="(item.is_single == 1 && item.relate_id.length == 1) ? false : true"-->
                                              <li class="add_approve_btn" >
                                                  <el-popover placement="top"   :ref="'userPopover' + ccIndex"   trigger="click">
                                                      <i class="el-icon-plus" slot="reference"></i>
                                                      <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                      <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                      </el-option>
                                                  </el-select>
                                                  </el-popover>
                                              </li>
                                          </ul>
                                      </el-form-item>
                                  </template>

                                  <!--指定成员选择人员-->
                                  <el-form-item prop="cc_users" label="添加成员（可多选）" class="form_item_border_top label-bold" v-if="item.type === 'specified'">
                                      <ul class="approve_user_list">
                                          <li :key="userIndex" class="approve_user_item" v-for="(user,userIndex) in item.relate_id">
                                              <img :src="user.avatar ?  user.avatar: defaultImg" alt="" class="head_img"  @error="handleError">
                                              <span v-text="user.relate_name"></span>
                                              <i @click="handleDelCCUsers(userIndex,item)" class="el-icon-error"></i>
                                          </li>
                                          <li class="add_approve_btn">
                                              <el-popover placement="top"  :ref="'userPopover'+ccIndex"   trigger="click">
                                                  <i class="el-icon-plus" slot="reference"></i>
                                                  <el-select :remote-method="getUserList"  value collapse-tags  filterable  placeholder="请选择成员"  remote  size="small">
                                                      <el-option :key="user.uid"  :label="user.name"  :value="user.uid"    @click.native="handleSelectCCUsers(user,item,ccIndex)"  v-for="user in userList">
                                                      </el-option>
                                                  </el-select>
                                              </el-popover>
                                          </li>
                                      </ul>
                                  </el-form-item>

                                  <!--人员标签/人员标签-->
                                  <el-form-item prop="cc_role_ids" label="人员标签" class="form_item_border_top label-bold" v-if="item.type === 'user_tags'">
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              选择人员标签：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select :key="'cc_role_ids' + ccIndex" filterable multiple placeholder="请选择人员标签" collapse-tags   v-model="item.relate_ids" @remove-tag="handleSelectCCRemoveTags($event,item,ccIndex)">
                                                  <el-option :key="role.id" :label="role.name" :value="role.id" @click.native="handleSelectCCTags(role,item,ccIndex)"  v-for="role in roleList"></el-option>
                                              </el-select>
                                              <p class="del_relate_class" v-if="item.del_relate_id && item.del_relate_id.length > 0">
                                                  人员标签被删除:
                                                  <span v-text="item.del_relate_id.map(map => map.relate_name).join(',')"></span>
                                              </p>
                                          </div>
                                       </div>
                                  </el-form-item>

                                  <!--连续多级上级-->
                                  <el-form-item prop="successive_superior" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_superior'">
                                      <p class="quick_tips">设置后，该节点将从直属上级到已选的层级依次审批</p>
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              提交人的：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select :key="'successive_superior' + ccIndex"  placeholder="请选择" remote v-model="item.relate_ids_string">
                                                  <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id"  @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)"  v-for="level in multiLevelSuperiorList"></el-option>
                                              </el-select>
                                          </div>
                                      </div>
                                  </el-form-item>

                                  <!--连续多级部门-->
                                  <el-form-item prop="successive_department" label="设置审批层级" class="form_item_border_top label-bold" v-if="item.type === 'successive_department'">
                                      <p class="quick_tips">设置后，该节点将从直属部门负责人到已选层级的部门负责人依次审批</p>
                                      <div class="form_item_wrap">
                                          <div class="form_item_name">
                                              提交人的：
                                          </div>
                                          <div class="form_item_value">
                                              <el-select  :key="'successive_department' + ccIndex" placeholder="请选择" remote v-model="item.relate_ids_string">
                                                  <el-option :key="level.relate_id" :label="level.relate_name" :value="level.relate_id" @click.native="handleSelectCCSuperiorDepartment(level,item,ccIndex)" v-for="level in multiLevelDepartmentsList"></el-option>
                                              </el-select>
                                          </div>
                                      </div>
                                  </el-form-item>

                              </li>
                          </ul>
                      </div>
                      <div class="prompt_text">
                          提示：<br>
                          在审批通过后即会抄送给设置人员（可添加多种抄送人）
                      </div>
                      <div class="mt_16">
                          <el-button type="text" v-if="endProcessForm.cc_info.length<8"   @click="handleClickAddCCInfo('endProcessForm')"><i class="el-icon-plus"></i>添加抄送人</el-button>
                      </div>

                  </div>
              </el-form>
          </template>


          <div class="approval_process_form_footer" v-if="approvalProcessType">
              <el-button @click="handleClickCancel" size="small">取消</el-button>
              <el-button @click="handleClickSubmit" size="small" type="primary">提交</el-button>
          </div>
        </div>

        <userDepartmentPostSelection :userDepartmentPostVisible.sync="userDepartmentPostVisible" v-if="userDepartmentPostVisible" :userDepartmentPostSelected="userDepartmentPostSelected" :selectType="'departmentUserPost'" :userDepartmentPostTitle="'选择人员'"  @success="userDepartmentPostSuccess"/>

    </div>
</template>
<script>
import approveAdminProcessNode from './approvalProcessNode'
import userDepartmentPostSelection from "@/components/pComponents/userDepartmentPostSelection.vue";
import { GetUserList,GetDepartmentList,PersonTagAllList,getOrderAfterSalesType,GetHolidayRuleList } from "@/api/index.js"
import {fieldOperatorText} from '@/utils'

export default {
    name: "approveAdminProcess",
    components: {
        approveAdminProcessNode,
        userDepartmentPostSelection
    },
    props: {
        fieldList: {
            type: Array,
            default: () => []
        }, //全部字段
        node_info: {
            type: Object,
            default: () => {}
        },
        approvalType: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            nodeInfoData: {
                type: 'start',
                name: '提交',
                sort: 0,
                level: 1,
                handle: {},
                cc_info: [],
                rules: [],
                field_auth:[],//表单权限
                childNode: {
                    type: 'approval',
                    name: '审批',
                    sort: 0,
                    level: 2,
                    allow_transfer:0,
                    allow_add_signature: 0,
                    allow_return: 0,
                    handle: {},
                    cc_info: [],
                    rules: [],
                    field_auth:[],//表单权限
                    childNode: {
                        type: 'conduct',
                        name: '办理',
                        sort: 0,
                        level: 3,
                        allow_transfer: 0,
                        allow_add_signature: 0,
                        allow_return: 0,
                        handle: {},
                        cc_info: [],
                        rules: [],
                        field_auth:[],//表单权限
                        childNode: {
                            type: 'end',
                            name: '结束',
                            sort: 0,
                            level: 4,
                            handle: {},
                            cc_info: [],
                            rules: [],
                            childNode: {},
                            conditionNodes: [],
                        },
                        conditionNodes: []
                    },
                    conditionNodes: [],
                },
                conditionNodes: [],
            },
            nodeId: 0,
            nodeUuid:0, //当前所选中的流程
            startProcessForm:{
                name: '提交',
                cc_info: [],//抄送人
                field_auth:[],//表单权限
            }, //提交表单
            approvalForm:{
                name: '',
                handle: {
                    operation_type: 'manual_approval', //人工审批=manual_approval 自动通过=auto_approve 自动拒绝=auto_deny
                    reason: '', //原因
                    type: 'superior', //审批人
                    is_single: 1, //添加成员 1==单人 2==多人  （提交人自选）
                    is_all_company: 1, //选择范围 1==全公司 2==指定成员 （提交人自选）
                    is_null_auto: 1, //审批人为空时 1==自动通过 2==指定人员办理 3==转交给审批管理员
                    null_relate_id: [], //审批人为空时 选择指定成员  选择人员
                    relate_id:[],
                    relate_ids:[],
                    relate_ids_string:'',
                    approval_mode: 1, //审批人为多人时 1==会签 2==或签 3==依次审批
                    consistency_type: 1, //审批人与提交人为同一人时 1==自动通过 2==提交审批人 3==转交给直属上级 4==转交给提交的部门负责人审批
                },
                allow_transfer: 0,//是否允许转交
                allow_add_signature: 0,//是否允许加/减签
                allow_return: 0,//是否允许回退
                cc_info: [],//抄送人员
                field_auth:[],//表单权限
            }, //审批表单
            conductForm:{
                name: '',
                handle: {
                    type: 'superior', //办理人
                    is_single: 1, //添加成员 1==单人 2==多人  （提交人自选）
                    is_all_company: 1, //选择范围 1==全公司 2==指定成员 （提交人自选）
                    is_null_auto: 2, //办理人为空时 1==自动通过 2==指定人员办理 3==转交给审批管理员
                    null_relate_id: [], //办理人为空时 选择指定成员  选择人员
                    approval_mode: 1,
                    relate_id:[],
                    relate_ids:[],
                    relate_ids_string:'',
                },
                allow_transfer: 0,//是否支持转发操作
                allow_add_signature: 0,//是否可以加签
                allow_return: 0,//是否支持退回操作
                cc_info: [],
                field_auth:[],//表单权限
            },//办理表单
            endProcessForm:{
                name: '结束',
                cc_info: [],//抄送人
            }, //结束表单
            conditionProcessForm:{
                name:'',
                rules: [
                    [
                        {
                            type: 'field',
                            field_key: '',
                            field_name: '',
                            operator: '',
                            field_value: '',
                        }
                    ]
                ],
                sort:0,
            }, //条件表单
            approvalProcessType:'', //所选流程
            approvalProcessNode:{}, //所选流程
            userTypeList: [
                {
                    label: '直属上级',
                    value: 'superior'
                },
                {
                    label: '部门负责人',
                    value: 'department_head'
                },
                {
                    label: '指定成员',
                    value: 'specified'
                },
                {
                    label: '提交人自选',
                    value: 'submitter_choice'
                },
                {
                    label: '提交人本人',
                    value: 'submitter_self'
                },
                {
                    label: '人员标签',
                    value: 'user_tags'
                },
                {
                    label: '连续多级上级',
                    value: 'successive_superior'
                },
                {
                    label: '连续多级部门',
                    value: 'successive_department'
                },
            ],
            roleList:[],//人员标签列表
            userList:[],//人员列表
            tabActive:1,
            conditionFieldList: [], //可以作为条件选择的字段

            multiLevelSuperiorList:[
                {relate_id:1,relate_name:'最高上级'},
                {relate_id:2,relate_name:'最高上级减1级'},
                {relate_id:3,relate_name:'最高上级减2级'},
                {relate_id:4,relate_name:'最高上级减3级'},
                {relate_id:5,relate_name:'最高上级减4级'},
                {relate_id:6,relate_name:'最高上级减5级'},
            ],
            multiLevelDepartmentsList:[
                {relate_id:1,relate_name:'最高级部门负责人'},
                {relate_id:2,relate_name:'最高级部门负责人减1级部门'},
                {relate_id:3,relate_name:'最高级部门负责人减2级部门'},
                {relate_id:4,relate_name:'最高级部门负责人减3级部门'},
                {relate_id:5,relate_name:'最高级部门负责人减4级部门'},
            ],

            promoterSelectInfo:null, //条件中-选择的发起人
            userDepartmentPostSelected:[],//条件中-选择的发起人的值
            userDepartmentPostVisible:false,//条件中-选择发起人弹窗
            departmentList:[],//部门

            nodeValidate:true ,//校验是否能提交
            permissions_form_radio:1,
            field_auth:[], //表单权限字段
            fieldAuthList:[],
            autoplay_delay_time:'',
            is_queue:0,
            canOperate:0,
            holidayRules:[]

        }
    },
    created() {

        if(this.approvalType == '' ||  this.approvalType == 'order_after_sale'){
            this.canOperate = 1
        }
        if(this.node_info && this.node_info.id){
            this.nodeInfoData = JSON.parse(JSON.stringify(this.node_info))
        }
        this.recursionData(this.nodeInfoData)
        if(this.nodeInfoData){
            this.getPersonTagList()
        }
        this.getUserList()
    },
    methods: {
        handleMouseDown(event) {
            let mouseX = event.clientX;
            let mouseY = event.clientY;

            const handleMouseMove = (event) => {
                let deltaX = event.clientX - mouseX;
                let deltaY = event.clientY - mouseY;
                mouseX = event.clientX;
                mouseY = event.clientY;

                this.$refs.approval_process_left.scrollTo(
                        this.$refs.approval_process_left.scrollLeft - deltaX,
                        this.$refs.approval_process_left.scrollTop - deltaY
                );
            };

            const handleMouseUp = () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        },
        // 获取表单权限的字段
        get_field_auth(data){
            if(data.type == 'start'){
                if(this.approvalType == 'order_add' || this.approvalType == 'order_purchase'){return false}
            }
            if(this.approvalType == '' || this.approvalType == 'order_add' || this.approvalType == 'order_purchase'){
                let fieldAuthList = []
                if(this.approvalType == 'order_add'){  //订单编辑
                    let field_list_filter = []
                    this.fieldList.forEach(item=>{
                        if(item._child){
                            field_list_filter = field_list_filter.concat(item._child)
                        }
                    })
                    // 允许设置的字段
                    // 产品信息、代采销售金额、合同、是否需要发货、收货人、收货人电话、收货地址、其他自定义字段、自定义订单金额
                    field_list_filter.forEach(item=>{
                        if(item.field_key == 'contract_file' || item.field_key == 'order_goods' || item.field_key == 'purchase_price' || item.p_field_key == 'receive_information' || item.is_system == 0){
                            fieldAuthList.push(item)
                        }
                    })
                } else if(this.approvalType == 'order_purchase'){ //订单代采
                    fieldAuthList = [
                        {field_key: "supplier",field_name: "供应商"},
                        {field_key: "goods_name",field_name: "产品名称"},
                        {field_key: "price",field_name: "单价"},
                        {field_key: "num",field_name: "数量"},
                        {field_key: "discount_price",field_name: "总优惠金额"},
                        {field_key: "remarks",field_name: "备注"},
                        {field_key: "file",field_name: "附件"},
                    ]
                }else{
                    fieldAuthList = this.fieldList
                }
                let field_list = []
                fieldAuthList.forEach(item => {

                    if(item.field_type != 'control'){
                        let findInfo = data.field_auth.find(find => find.field_key == item.field_key)
                        field_list.push({
                            field_key: item.field_key,
                            field_auth:(findInfo && findInfo.field_auth) ? findInfo.field_auth : data.type == 'start' ? 2 : 1,
                        })
                    }

                })
                this.fieldAuthList = fieldAuthList
                this.field_auth = field_list
                if(this.field_auth.filter(find => find.field_auth == 2).length == this.field_auth.length){
                    this.permissions_form_radio = 2
                }else if(this.field_auth.filter(find => find.field_auth == 3).length == this.field_auth.length){
                    this.permissions_form_radio = 3
                }else{
                    this.permissions_form_radio = 1
                }
            }
        },
        handleClickFieldAuth(value){
            this.field_auth.forEach(item => {
                this.$set(item,'field_auth',value)
            })
        },
        //获取作为条件的字段
        getConditionFieldList() {
            if(this.approvalType == 'order_after_sale'){
                getOrderAfterSalesType({  }).then((res) => {
                    if (res.code == 200) {
                        this.conditionFieldList = {
                            order_after_sale: {
                                condition_type: "options",
                                field_key: "order_after_sale",
                                field_name: "订单售后",
                                field_type: "order_after_sale",
                                is_required: 1,
                                is_reset: 0,
                                is_system: 0,
                                is_system_key: 0,
                                is_unique: 0,
                                sort: 1,
                                rules: [],
                                extend:{
                                    options:res.data
                                },
                                select_range: '1' //跟部门一样

                            }
                        }
                    }
                });
            }else{
                this.conditionFieldList = {
                    promoter: {
                        condition_type: "promoter",
                        field_key: "promoter",
                        field_name: "发起人",
                        field_type: "promoter",
                        is_list_show: "1",
                        is_required: true,
                        is_system: "0",
                        is_system_key: "0",
                        placeholder: "请输入",
                        rules: [],
                        sort: 1,
                        select_range: '1' //跟部门一样
                    }
                }

                this.fieldList.forEach(item => {
                    if (item.field_type === 'number' || item.field_type === 'money') {
                        this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                        this.conditionFieldList[item.field_key].condition_type = 'number'
                    } else if (item.field_type === 'date_range') {
                        if (item.extend.auto_computed) { //计算时长
                            this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                            this.conditionFieldList[item.field_key].condition_type = 'number'
                            this.conditionFieldList[item.field_key].field_name = item.field_name + '-时长'
                        }
                    } else if (item.field_type === 'compute_mode') {
                        this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                        this.conditionFieldList[item.field_key].condition_type = 'number'
                    } else if (item.field_type === 'radio' || item.field_type === 'checkbox') {
                        this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                        this.conditionFieldList[item.field_key].condition_type = 'options'
                    } else if (item.field_type === 'date') {
                        if (!item.extend.default) {
                            this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                            this.conditionFieldList[item.field_key].condition_type = 'date'
                        }
                    } else if (item.field_type === 'department') {
                        this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                        this.conditionFieldList[item.field_key].condition_type = 'department'
                        if (this.departmentList.length === 0) {
                            this.getDepartmentList()
                        }
                    } else if (item.field_type === 'control') {
                        if (item.field_key === 'control_rest') { //请假
                            if(this.holidayRules.length == 0){
                                this.getHolidayRuleList()
                            }
                            item._child.forEach(child => {
                                if (child.field_key === 'rest_holiday_rule_id') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'options'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                } else if (child.field_key === 'rest_duration') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'number'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                } else if (child.field_key === 'rest_start_time' || child.field_key === 'rest_end_time') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'date'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                }
                            })
                        } else if (item.field_key === 'control_overtime'){ //加班
                            item._child.forEach(child => {
                                if (child.field_key === 'overtime_rule_id') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'options'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                } else if (child.field_key === 'overtime_duration') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'number'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                } else if (child.field_key === 'overtime_start_time' || child.field_key === 'overtime_end_time') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'date'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                }
                            })
                        } else if (item.field_key === 'control_travel') { //出差
                            item._child.forEach(child => {
                                if (child.field_key === 'travel_total_duration') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'number'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                }
                            })
                        } else if (item.control_type === 'reimbursement') {
                            item._child.forEach(child => {
                                if (child.field_key === 'reimbursement_payment_type') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'options'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                } else if (child.field_key === 'reimbursement_total_amount') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'number'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                } else if (child.field_key === 'reimbursement_form') {
                                    child._child.forEach(grandson => {
                                        if (grandson.field_key === 'reimbursement_type') {
                                            this.conditionFieldList[grandson.field_key] = JSON.parse(JSON.stringify(grandson))
                                            this.conditionFieldList[grandson.field_key].condition_type = 'options'
                                            this.conditionFieldList[grandson.field_key].field_name = item.field_name + '.' + child.field_name + '.' + grandson.field_name
                                            this.getReimbursementTypeList().then(res => {
                                                this.reimbursementTypes = res.filter(res_item => grandson.options_ids.indexOf(res_item.reimbursements_type_id) > -1)
                                            })
                                        }
                                    })
                                }
                            })
                            if (item.is_add_many_reimbursement) {

                            } else {

                            }
                        } else if (item.control_type === 'stock_movement') {
                            item._child.forEach(child => {
                                if (child.field_key === 'stock_movement_product_total_amount' && child.initial_display == false) {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'number'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                } else if (child.field_key === 'stock_movement_type' && item.needs_to_return == true) {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'options'
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                }
                            })
                        }
                    }
                })

            }

        },
        //获取控件对应的条件
        getOperatorSelectList(child) {
            let arr = []
            if (child.field_key) {
                const field = this.conditionFieldList[child.field_key]
                if (field) {
                    if (field.field_type === 'radio') {
                        arr = [
                            {label: '选中', value: 'in'},
                            {label: '未选中', value: 'not_in'}
                        ]
                    } else if (field.field_type === 'checkbox') {
                        arr = [
                            {label: '完全匹配', value: 'eq'},
                            {label: '属于以下任意', value: 'between'},
                            {label: '不属于', value: 'not_between'},
                        ]
                    } else if (field.field_type === 'number' || field.field_type === 'money' || field.field_type === 'compute_mode' || field.field_type === 'computed_money' || field.field_type === 'date_range' || field.field_type === 'duration') {
                        arr = [
                            {label: '大于', value: 'gt'},
                            {label: '大于等于', value: 'egt'},
                            {label: '等于', value: 'eq'},
                            {label: '小于等于', value: 'elt'},
                            {label: '小于', value: 'lt'},
                        ]
                    } else if (field.field_type === 'date' || field.field_type === 'attendance_date') {
                        arr = [
                            {label: '大于', value: 'gt'},
                            {label: '等于', value: 'eq'},
                            {label: '小于', value: 'lt'},
                        ]
                    } else if (field.field_type === 'department' || field.field_type === 'promoter' || field.field_type === 'order_after_sale') {
                        if (field.select_range === '1') {
                            arr = [
                                {label: '属于以下任意', value: 'between'},
                                {label: '不属于', value: 'not_between'},
                            ]
                        } else {
                            arr = [
                                {label: '完全匹配', value: 'eq'},
                                {label: '属于以下任意', value: 'between'},
                                {label: '不属于', value: 'not_between'},
                            ]
                        }
                    }
                }
            }
            return arr
        },

        //选择条件字段变化事件
        handleSelectConditionFieldChange(val, child) {
            child.operator = ''
            child.field_value = ''
            const field = this.conditionFieldList[child.field_key]
            child.field_name = field.field_name
            child.field_type = field.field_type
            if (field.condition_type === 'date') {
                child.field_value = {
                    value: '',
                    date: '',
                }
            } else if (field.condition_type === 'department') {
                child.field_value = {
                    titles: [],
                    dids: []
                }
            } else if (field.condition_type === 'promoter') {
                child.field_value = {
                    titles: [],
                    ids: [],
                    values: []
                }
            } else if (field.condition_type === 'number') {
                child.field_value = undefined
            } else if (field.condition_type === 'options') {
                if (field.field_type === 'checkbox') {
                    child.field_value = {
                        text: [],
                        value: []
                    }
                } else {
                    child.field_value = {
                        text: [],
                        value: []
                    }
                }
            }
            child.p_field_key = field.p_field_key
        },
        // 条件select选择值获取text
        handleCheckBoxCheckChange(child,field){
            this.$nextTick(()=>{
                if(field.field_key == 'rest_holiday_rule_id'){
                    child.field_value.text = this.holidayRules.filter(option => String(child.field_value.value).includes(option.value)).map(option => option.label)
                }else{
                    if(Array.isArray(child.field_value.value)){
                        child.field_value.text = field.extend.options.filter(option => child.field_value.value.includes(option.value)).map(option => option.label)
                    }else{
                        child.field_value.text = field.extend.options.filter(option => child.field_value.value == option.value).map(option => option.label)
                    }
                }
          })
        },
        // 获取请假的类型
        getHolidayRuleList(field){
            GetHolidayRuleList({
                page: 1,
                pageSize: 9999,
            }).then(res => {
                if (res.code === 200) {
                    this.holidayRules = res.data.map((map)=>{
                        return {
                            label: map.name,
                            value: map.id,
                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },

        // 获取人员标签
        getPersonTagList(keyword){
            PersonTagAllList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.roleList = res.data || [];
                    this.tagUserRemove(this.nodeInfoData)
                }
            });
        },
        // 人员标签被删除
        tagUserRemove(node){
            var roleIds = this.roleList.map(role => role.id);
            if(node && node.handle && node.handle.type == 'user_tags'){
                let del_relate_id = node.handle.relate_id.filter(relate => !roleIds.includes(relate.relate_id));
                this.$set(node.handle, 'del_relate_id', del_relate_id) //被删除的人员标签
                this.$set(node.handle, 'relate_id', node.handle.relate_id.filter(relate => roleIds.includes(relate.relate_id)))
            }
            if(node.cc_info && node.cc_info.length>0){
                node.cc_info.forEach(item =>{
                    if(item.type == 'user_tags'){
                        let cc_del_relate_id = item.relate_id.filter(relate => !roleIds.includes(relate.relate_id));
                        this.$set(item, 'del_relate_id', cc_del_relate_id) //被删除的人员标签
                        this.$set(item, 'relate_id', item.relate_id.filter(relate => roleIds.includes(relate.relate_id)))
                    }
                })
            }

            if (node.childNode && node.childNode.type) {
                this.tagUserRemove(node.childNode);
            }
            if (node.conditionNodes && node.conditionNodes.length > 0) {
                for (let i = 0; i < node.conditionNodes.length; i++) {
                    this.tagUserRemove(node.conditionNodes[i]);
                }
            }
        },
        // 获取人员
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        // 获取部门
        getDepartmentList(){
            GetDepartmentList({name: this.keyWord}).then(res=> {
                if(res.code === 200) {
                    this.departmentList = res.data || []
                }
            })
        },
        // 清除选中的发起人
        handleClickClearPromoter(child) {
            child.field_value.values = []
        },
        // 点击弹出选择发起人
        handleClickPromoter(child) {
            this.promoterSelectInfo = child
            this.userDepartmentPostSelected = child.field_value.values
            this.userDepartmentPostVisible = true
        },
        // 点击删除发起人
        handleClickRemovePromoter(event,child) {
            child.field_value.values.forEach((item, index) => {
                if (item.relate_type_id == event) {
                    child.field_value.values.splice(index, 1)
                }
            })
        },
        // 发起人选择回调
        userDepartmentPostSuccess(data){
            this.promoterSelectInfo.field_value.values = data
            this.promoterSelectInfo.field_value.ids = data.map((item)=>{
                return item.relate_type_id
            })
            this.promoterSelectInfo.field_value.titles = data.map((item)=>{
                return item.relate_name
            })
        },

        //选择条件中的部门事件
        handleDepartmentCheckChange(data, checked, indeterminate, child) {
            if (checked) {
                child.field_value.titles.push(data.relate_name)
                child.field_value.dids.push(data.relate_id)
            } else {
                child.field_value.titles.splice(child.field_value.titles.indexOf(data.relate_name), 1)
                child.field_value.dids.splice(child.field_value.dids.indexOf(data.relate_id), 1)
            }
        },

        handleDepartmentFocus(child, refdef) {
            let ref = 'department' + refdef
            const keys = child.field_value.dids.map(item => item)
            child.field_value.dids = []
            child.field_value.titles = []
            this.$refs[ref][0].setCheckedKeys([])
            this.$nextTick(() => {
                this.$refs[ref][0].setCheckedKeys(keys)
            })
        },

        // 点击删除部门
        handleClickRemoveDepartment(tag, child, refdef) {
            child.field_value.dids.splice(0, 1)
            this.handleDepartmentFocus(child, refdef)
        },
        // 清除部门
        handleClickClearDepartment(child, refdef) {
            child.field_value.dids = []
            this.handleDepartmentFocus(child, refdef)
        },
        // 当图片加载失败时，将 src 设置为默认图片
        handleError(event) {
            event.target.src = this.defaultImg;
        },
        // 点击节点
        handleClickNode(data){

            this.tabActive = 1
            let item = data.node
            this.nodeUuid = data.nodeUuid
            if(item.type != 'condition' && item.type != 'end'){
                this.get_field_auth(item)
            }

            this.setRelateIds(item)

            if (item.type === 'start') {
                this.startProcessForm = JSON.parse(JSON.stringify(this.$options.data().startProcessForm))
                if (item.cc_info.length > 0) {
                    this.startProcessForm.cc_info = JSON.parse(JSON.stringify(item.cc_info))
                }
                this.startProcessForm.name = item.name
            } else if (item.type === 'approval') {
                this.approvalForm = JSON.parse(JSON.stringify(this.$options.data().approvalForm))
                if (Object.values(item.handle).length > 0) {
                    this.approvalForm.handle = JSON.parse(JSON.stringify(item.handle))
                }
                if (item.cc_info.length > 0) {
                    this.approvalForm.cc_info = JSON.parse(JSON.stringify(item.cc_info))
                }
                this.approvalForm.name = item.name
                this.approvalForm.allow_transfer = item.allow_transfer
                this.approvalForm.allow_add_signature = item.allow_add_signature
                this.approvalForm.allow_return = item.allow_return
            } else if (item.type === 'conduct') {
                this.conductForm = JSON.parse(JSON.stringify(this.$options.data().conductForm))
                if (Object.values(item.handle).length > 0) {
                    this.conductForm.handle = JSON.parse(JSON.stringify(item.handle))
                }
                if (item.cc_info.length > 0) {
                    this.conductForm.cc_info = JSON.parse(JSON.stringify(item.cc_info))
                }
                this.conductForm.name = item.name
                this.conductForm.allow_transfer = item.allow_transfer
                this.conductForm.allow_add_signature = item.allow_add_signature
                this.conductForm.allow_return = item.allow_return
            } else if (item.type === 'end') {
                this.endProcessForm = JSON.parse(JSON.stringify(this.$options.data().endProcessForm))
                if (item.cc_info.length > 0) {
                    this.endProcessForm.cc_info = JSON.parse(JSON.stringify(item.cc_info))
                }
                this.endProcessForm.name = item.name
            } else if (item.type === 'condition') {
                this.conditionProcessForm = JSON.parse(JSON.stringify(this.$options.data().conditionProcessForm))
                this.conditionProcessForm.name = item.name
                this.conditionProcessForm.sort = item.sort
                this.conditionProcessForm.rules = item.rules
                this.getConditionFieldList()
                let nodeInfo = this.findParentNodeById(this.nodeInfoData, item.uuid) //找到当前节点的父节点
                this.conditionLength = nodeInfo.conditionNodes.length - 1
            }
            this.approvalProcessType = item.type
            this.approvalProcessNode = item
        },
        // 设置 relate_ids 和 relate_ids_strings
        setRelateIds(data){
            if(data && data.handle && data.handle.relate_id){
                this.$set(data.handle,'relate_ids',data.handle.relate_id.map(item => item.relate_id))
                this.$set(data.handle,'relate_ids_string',Number(data.handle.relate_id.map(item => item.relate_id).join()))
            }
            data.cc_info.forEach((ccItem,ccIndex)=>{
                 if(ccItem.relate_id) {
                     this.$set(ccItem, 'relate_ids', ccItem.relate_id.map(item => item.relate_id))
                     this.$set(ccItem, 'relate_ids_string', Number(ccItem.relate_id.map(item => item.relate_id).join()))
                 }
            })
        },


        // 添加审批,办理,条件分支 ---- 返回数据
        nodeReceiveData(data){
            let node = data.node
            let type = data.type
            let direction = data.direction
            if (type == 'add') {
                this.findAndReplaceNodeById(this.nodeInfoData, node.uuid, node)
            } else if (type == 'del') {
                if (node.type == 'condition') {
                    if(this.nodeUuid == node.uuid){ //如果右侧选中的是自己
                        this.approvalProcessType = ''
                        this.approvalProcessNode = {}
                        this.nodeUuid = 0
                    }
                    let nodeInfo = this.findParentNodeById(this.nodeInfoData, node.uuid)
                    // 如果大于俩个条件的话
                    if (nodeInfo.conditionNodes.length > 2) {
                        const index = nodeInfo.conditionNodes.findIndex(item => item.uuid === node.uuid);
                        nodeInfo.conditionNodes.splice(index, 1);
                    } else {
                        const childNode = JSON.parse(JSON.stringify(nodeInfo.childNode.childNode))
                        const conditionNodes = JSON.parse(JSON.stringify(nodeInfo.childNode.conditionNodes))
                        // nodeInfo.childNode = childNode.type == "route" ? childNode.childNode : childNode
                        nodeInfo.childNode = nodeInfo.childNode.type == 'route' ? childNode : nodeInfo.childNode
                        nodeInfo.conditionNodes = conditionNodes
                        // nodeInfo.conditionNodes = []
                    }
                } else {
                    this.findNodeDelete(this.findParentNodeById(this.nodeInfoData, node.uuid), node)
                }
                // this.processType = ''
                // this.processItem = {}
            } else if (type == 'copy') {
                let nodeInfo = this.findParentNodeById(this.nodeInfoData, node.uuid)
                let newNode = JSON.parse(JSON.stringify(node))
                newNode.title = newNode.title + '(复制)'
                nodeInfo.conditionNodes.splice(node.sort + 1, 0, newNode)
            } else if (type == 'sort') {
                // direction 移动的方向
                let nodeInfo = this.findParentNodeById(this.nodeInfoData, node.uuid)
                let prevNode = node.sort != 0 ? JSON.parse(JSON.stringify(nodeInfo.conditionNodes[node.sort - 1])) : {}; // 移动的前一个
                let nextNode = JSON.parse(JSON.stringify(nodeInfo.conditionNodes[node.sort + 1])); // 移动的后一个
                let tempNode = JSON.parse(JSON.stringify(node)); // 备份当前节点的值
                if (direction === 'left') {
                    this.$set(nodeInfo.conditionNodes, node.sort - 1, tempNode);
                    this.$set(nodeInfo.conditionNodes, node.sort, prevNode);
                } else {
                    this.$set(nodeInfo.conditionNodes, node.sort + 1, tempNode);
                    this.$set(nodeInfo.conditionNodes, node.sort, nextNode);
                }
            }
            this.nodeId = 0
            this.recursionData(this.nodeInfoData)
            this.haveEditedBefore() //是否被编辑了
            this.$forceUpdate()
        },
        // 找到对应的，并赋值 添加
        findAndReplaceNodeById(node, targetNodeId, replacementData) {
            if (node.uuid === targetNodeId) {
                Object.assign(node, replacementData);
                return true;
            }
            let found = false;
            if (node.childNode && !found) {
                found = this.findAndReplaceNodeById(node.childNode, targetNodeId, replacementData);
            }
            if (node.conditionNodes && !found) {
                for (let i = 0; i < node.conditionNodes.length; i++) {
                    found = this.findAndReplaceNodeById(node.conditionNodes[i], targetNodeId, replacementData);
                    if (found) {
                        break;
                    }
                }
            }
            return found;
        },
        // 找到对应的父节点
        findParentNodeById(node, nodeId) {
            if (node.childNode && node.childNode.uuid === nodeId) {
                return node; // 目标节点为子节点，返回当前节点作为父节点
            }
            if (node.conditionNodes) {
                for (const conditionNode of node.conditionNodes) {
                    if (conditionNode.uuid === nodeId) {
                        return node; // 目标节点为条件节点，返回当前节点作为父节点
                    }
                    const result = this.findParentNodeById(conditionNode, nodeId); // 在条件节点中递归查找
                    if (result) {
                        return result; // 找到目标节点的父节点，返回该节点
                    }
                }
            }
            if (node.childNode) {
                const result = this.findParentNodeById(node.childNode, nodeId); // 在子节点中递归查找
                if (result) {
                    return result; // 找到目标节点的父节点，返回该节点
                }
            }
            return null; // 没有找到目标节点的父节点，返回null
        },
        // 并删除
        findNodeDelete(node, newNode) {
            node.childNode = newNode.childNode
            node.conditionNodes = newNode.conditionNodes
        },
        // 子组件返回数据
        receiveData(data) {
            let node = data.node
            let type = data.type
            let direction = data.direction
            if (type == 'add') {
                this.findAndReplaceNodeById(this.nodeInfoData, node.uuid, node)
            } else if (type == 'del') {
                if (node.type == 'condition') {
                    let nodeInfo = this.findParentNodeById(this.nodeInfoData, node.uuid)
                    // 如果大于俩个条件的话
                    if (nodeInfo.conditionNodes.length > 2) {
                        const index = nodeInfo.conditionNodes.findIndex(item => item.uuid === node.uuid);
                        nodeInfo.conditionNodes.splice(index, 1);
                    } else {
                        const childNode = JSON.parse(JSON.stringify(nodeInfo.childNode.childNode))
                        const conditionNodes = JSON.parse(JSON.stringify(nodeInfo.childNode.conditionNodes))
                        // nodeInfo.childNode = childNode.type == "route" ? childNode.childNode : childNode
                        nodeInfo.childNode = nodeInfo.childNode.type == 'route' ? childNode : nodeInfo.childNode
                        nodeInfo.conditionNodes = conditionNodes
                        // nodeInfo.conditionNodes = []
                    }


                } else {
                    this.findNodeDelete(this.findParentNodeById(this.nodeInfoData, node.uuid), node)
                }
                this.processType = ''
                this.processItem = {}

            } else if (type == 'copy') {
                let nodeInfo = this.findParentNodeById(this.nodeInfoData, node.uuid)
                let newNode = JSON.parse(JSON.stringify(node))
                newNode.title = newNode.title + '(复制)'
                nodeInfo.conditionNodes.splice(node.sort + 1, 0, newNode)
            } else if (type == 'sort') {
                // direction 移动的方向
                let nodeInfo = this.findParentNodeById(this.nodeInfoData, node.uuid)

                let prevNode = node.sort != 0 ? JSON.parse(JSON.stringify(nodeInfo.conditionNodes[node.sort - 1])) : {}; // 移动的前一个
                let nextNode = JSON.parse(JSON.stringify(nodeInfo.conditionNodes[node.sort + 1])); // 移动的后一个
                let tempNode = JSON.parse(JSON.stringify(node)); // 备份当前节点的值
                if (direction === 'left') {
                    this.$set(nodeInfo.conditionNodes, node.sort - 1, tempNode);
                    this.$set(nodeInfo.conditionNodes, node.sort, prevNode);
                } else {
                    this.$set(nodeInfo.conditionNodes, node.sort + 1, tempNode);
                    this.$set(nodeInfo.conditionNodes, node.sort, nextNode);
                }
            }
            this.nodeId = 0
            this.recursionData(this.nodeInfoData)
            this.$forceUpdate()
        },
        // 递归处理数据
        recursionData(node) {
            node.uuid = this.nodeId++;
            if (node.childNode && node.childNode.type) {
                this.recursionData(node.childNode);
            }
            if (node.conditionNodes && node.conditionNodes.length > 0) {
                let conditionIndex = 0;
                for (let i = 0; i < node.conditionNodes.length; i++) {
                    if (node.conditionNodes[i].type === "condition") {
                        this.$set(node.conditionNodes[i], 'sort', conditionIndex++)
                        this.$set(node.conditionNodes[i], 'penultimate', false)
                        if(node.conditionNodes[i].name != '默认条件' ){
                            this.$set(node.conditionNodes[i], 'rulesText', this.rulesTextFunction(node.conditionNodes[i].rules,'no_check'))
                        }
                    }
                    this.recursionData(node.conditionNodes[i]);
                }
                this.$set(node.conditionNodes[node.conditionNodes.length - 2], 'penultimate', true) //证明是条件中的倒数第二个
            }
        },
        // 删除字段后条件中运用了该字段的要相应做出修改
        delFieldCondition(data){
            this.delFieldConditionRules(this.nodeInfoData,data.field_key)
            this.recursionData(this.nodeInfoData)
        },
        delFieldConditionRules(node, filed_key) {
            if (node.childNode) {
                this.delFieldConditionRules(node.childNode, filed_key);
            }
            if (node.conditionNodes) {
                node.conditionNodes.forEach((item, key) => {
                    this.delFieldConditionRules(item.childNode, filed_key);
                    let rules = item.rules;
                    if (rules && rules.length > 0) {
                        rules.forEach((rule, index) => {
                            rule.forEach((field, fieldIndex) => {
                                if (field.field_key == filed_key || field.p_field_key == filed_key) {
                                    rule.splice(fieldIndex, 1);
                                }
                            });
                            if (rule.length == 0) { // 如果规则为空，则从条件节点中删除该规则
                                item.rules.splice(index, 1);
                            }
                        });
                    }
                });
            }
        },
        // 点击右侧编辑标题
        handleClickEditTitle(formName) {
            this.$set(formName, 'is_edit', true)
            this.$nextTick(() => {
                if (this.$refs.titleInput[0]) {
                    this.$refs.titleInput[0].focus()
                } else if (this.$refs.titleInput) {
                    this.$refs.titleInput.focus()
                }
            })
        },
        // 右侧编辑标题后失去焦点
        handleTitleBlur(val, formName) {
            if (!formName.name) return this.$message.error('请输入标题')
            delete formName.is_edit
            this.$forceUpdate()
        },
        // 选择自动通过拒绝
        handleChangeOperationType(value){
            if(value == 'auto_approve'){ //自动通过
                this.$set(this.approvalForm,'name','自动通过')
            }else if(value == 'auto_deny'){ //自动拒绝
                this.$set(this.approvalForm,'name','自动拒绝')
            }else{
                this.$set(this.approvalForm,'name','审批')
            }
        },
        // 选择单人还是多人
        handleChangeIsSingle(field){
            if(this.approvalProcessType == 'approval'){
                if(field.type == 'submitter_choice' && field.is_single == 1){
                    this.$set(field,'approval_mode',3)
                }
            }
        },
         // 重新选择审批人、办理人类型
        handleChangeUserType(field){
            this.$set(field,'is_null_auto',1)
            this.$set(field,'approval_mode',1)
            if(this.approvalProcessType == 'conduct'){
                this.$set(field,'is_null_auto',2)
            }
            // 如果是审批||办理-并且选择的是连续多级上级,连续多级部门，则默认为依次审批
            if(this.approvalProcessType == 'approval' || this.approvalProcessType == 'conduct'){
                if(field.type == 'successive_superior' || field.type == 'successive_department' || (field.type == 'submitter_choice' && this.approvalProcessType == 'approval')){
                    this.$set(field,'approval_mode',3)
                }
            }
            this.$set(field,'consistency_type',1)
            this.$set(field,'null_relate_id',[])
            this.$set(field,'relate_ids',[])
            this.$set(field,'relate_ids_string','')
            this.$set(field,'relate_id',[])
        },
        //点击选择审批人员 - 类型为指定人员时
        handleSelectApproversUsers(user,field,fieldIds) {
            let json = {relate_id:user.uid,relate_name:user.name,avatar:user.avatar}
            if (field.findIndex(each => each.relate_id === json.relate_id) > -1) return this.$message.error(user.name + '已选择，不允许重复选择')
            field.push(json)
            fieldIds = field.map(item => item.relate_id).join()
            if (!Array.isArray(this.$refs.userPopover)) {
                this.$refs.userPopover.doClose()
            }
            this.getUserList('')
        },
        //点击删除审批人员 - 类型为指定人员时
        handleDelApproversUsers(index,field,fieldIds) {
            field.splice(index, 1)
            fieldIds = field.map(item => item.uid).join()
        },

        // 选择人员标签
        handleClickUserTags(user,field,fieldIds){
            let json =  { relate_id:user.id, relate_name:user.name, }
            let index = field.findIndex(find => find.relate_id == json.relate_id)
            if(index > -1){
                field.splice(index,1)
            }else{
                field.push(json)
                fieldIds = field.map(item => item.relate_id)
            }
        },
        // 删除人员标签
        handleRemoveUserTags(tag,field,fieldIds){
             field.splice(field.findIndex(find => find.relate_id == tag),1)
        },

        // 选择多上级、多部门
        handleSelectSuperiorDepartment(user,field,fieldIds){
            this[field].handle.relate_id = [user]
        },

        //选择抄送人
        handleSelectCCUsers(user, item,ccIndex) {
            let json = {relate_id:user.uid,relate_name:user.name,avatar:user.avatar}
            if (item.relate_id.findIndex(each => each.relate_id === json.relate_id) > -1) return this.$message.error(json.relate_name + '已选择，不允许重复选择')
            item.relate_id.push(json)
            item.relate_ids = item.relate_id.map(cc_user => cc_user.relate_id)
            if (Array.isArray(this.$refs['userPopover'+ ccIndex])) {
                this.$refs['userPopover'+ ccIndex][0].doClose()
            }
            this.getUserList('')
        },
        //点击删除抄送人
        handleDelCCUsers(index, item) {
            item.relate_id.splice(index, 1)
            item.relate_ids = item.relate_id.map(cc_user => cc_user.relate_id)
        },
        // 选择抄送人-人员标签
        handleSelectCCTags(user, item,ccIndex){
            let json =  { relate_id:user.id, relate_name:user.name, }
            let index = item.relate_id.findIndex(find => find.relate_id == json.relate_id)
            if(index > -1){
                item.relate_id.splice(index,1)
            }else{
                item.relate_id.push(json)
                item.relate_ids = item.relate_id.map(cc_user => cc_user.relate_id)
            }
        },
        // 删除人员标签
        handleSelectCCRemoveTags(tag,item,ccIndex){
            item.relate_id.splice(item.relate_id.findIndex(find => find.relate_id == tag),1)
        },
        // 选择抄送人-连续多级上级 -连续多级部门
        handleSelectCCSuperiorDepartment(user, item,ccIndex){
            item.relate_id = [user]
        },

        // 重新选择抄送人类型
        handleChangeCCUserType(item){
            this.$set(item,'relate_ids',[])
            this.$set(item,'relate_ids_string','')
            this.$set(item,'relate_id',[])
            this.$forceUpdate()
        },

        // 更改条件的优先级
        handleConditionPriority(command) {
            this.$set(this.conditionProcessForm, 'sort', command - 1)
        },
        // 添加抄送人
        handleClickAddCCInfo(formName){
            let cc_info = JSON.parse(JSON.stringify(this[formName].cc_info))
            let type_info = cc_info.map(item => {
                return item.type
            })
            let type = ''
            this.userTypeList.forEach(item =>{
                if(type_info.indexOf(item.value) == -1 && !type){
                    type = item.value
                }
            })

            let data = {
                type:type,
                is_single: 1,//单人还是多人
                is_all_company: 1,//是否是全公司
                relate_ids:[],
                relate_id:[],
                relate_ids_string:'',
            }
            this[formName].cc_info.push(data)
        },
        // 删除抄送人
        handleClickDelCCInfo(formName,index){
            this[formName].cc_info.splice(index,1)
        },
        // 添加条件组
        handleClickAddConditionGroup(){
            this.conditionProcessForm.rules.push([
                {
                    type: 'field',
                    field_key: '',
                    field_name: '',
                    operator: '',
                    field_value: '',
                }
            ])
        },
        // 删除条件组
        handleClickDelConditionGroup(index){
            this.conditionProcessForm.rules.splice(index, 1)
        },
        //点击添加条件
        handleClickAddCondition(item) {
            item.push({
                type: 'field',
                field_key: '',
                field_name: '',
                p_field_key: '',
                operator: '',
                field_value: '',
            })
        },
        //点击删除条件
        handleClickDelCondition(child_index, item, index) {
            item.splice(child_index, 1)
            if (item.length === 0) {
                this.conditionProcessForm.rules.splice(index, 1)
            }
        },
        // 取消
        handleClickCancel(){
            this.startProcessForm = JSON.parse(JSON.stringify(this.$options.data().startProcessForm))
            this.approvalForm = JSON.parse(JSON.stringify(this.$options.data().approvalForm))
            this.conductForm = JSON.parse(JSON.stringify(this.$options.data().conductForm))
            this.endProcessForm = JSON.parse(JSON.stringify(this.$options.data().endProcessForm))
            this.conditionProcessForm = JSON.parse(JSON.stringify(this.$options.data().conditionProcessForm))
            this.approvalProcessType = ''
            this.approvalProcessNode = {}
            this.tabActive = 1
        },

        // 保存
        handleClickSubmit(){
            // 判断不是条件分支，并且选择了人员标签，但是没选值的话
            if(this.approvalProcessType != 'condition'){
              if( this.roleVerification(this.approvalProcessType == 'start' ? this.startProcessForm
                      : this.approvalProcessType == 'approval' ? this.approvalForm
                      : this.approvalProcessType == 'conduct' ? this.conductForm : this.endProcessForm) == false){
                  return  false
              }
            }else{
                if(this.rulesTextFunction(this.conditionProcessForm.rules) == false){
                    return  false
                }
            }
            if(this.approvalProcessType == 'start'){

                let cc_info = JSON.parse(JSON.stringify(this.startProcessForm.cc_info))
                cc_info.forEach(item => {
                    delete item.relate_ids
                    delete item.relate_ids_string
                })
                this.$set(this.approvalProcessNode, 'cc_info',cc_info)
                this.$set(this.approvalProcessNode,'field_auth',this.field_auth)
            }else if(this.approvalProcessType == 'approval'){
                if(this.approvalForm.handle.is_null_auto == 2 && this.approvalForm.handle.null_relate_id.length == 0){
                    return this.$message.error('请至少选择一个指定人员')
                }
                this.$set(this.approvalProcessNode, 'name', this.approvalForm.name)
                this.$set(this.approvalProcessNode, 'allow_transfer', this.approvalForm.allow_transfer)
                this.$set(this.approvalProcessNode, 'allow_add_signature', this.approvalForm.allow_add_signature)
                this.$set(this.approvalProcessNode, 'allow_return', this.approvalForm.allow_return)
                let handle = JSON.parse(JSON.stringify(this.approvalForm.handle))
                delete handle.relate_ids
                delete handle.relate_ids_string
                this.$set(this.approvalProcessNode, 'handle', handle)
                let cc_info = JSON.parse(JSON.stringify(this.approvalForm.cc_info))
                cc_info.forEach(item => {
                    delete item.relate_ids
                    delete item.relate_ids_string
                })
                this.$set(this.approvalProcessNode, 'cc_info',cc_info)
                this.$set(this.approvalProcessNode,'field_auth',this.field_auth)
            }else if(this.approvalProcessType == 'conduct'){
                if((this.conductForm.handle.type == 'superior'||this.conductForm.handle.type == 'department_head' ||
                        this.conductForm.handle.type == 'user_tags' || this.conductForm.handle.type == 'successive_superior'
                        || this.conductForm.handle.type == 'successive_department') && this.conductForm.handle.is_null_auto == 2 && this.conductForm.handle.null_relate_id.length == 0){
                    return  this.$message.error('请至少选择一个指定人员')
                }
                this.$set(this.approvalProcessNode, 'name', this.conductForm.name)
                this.$set(this.approvalProcessNode, 'allow_transfer', this.conductForm.allow_transfer)
                this.$set(this.approvalProcessNode, 'allow_add_signature', this.conductForm.allow_add_signature)
                this.$set(this.approvalProcessNode, 'allow_return', this.conductForm.allow_return)
                let handle = JSON.parse(JSON.stringify(this.conductForm.handle))
                delete handle.relate_ids
                delete handle.relate_ids_string
                this.$set(this.approvalProcessNode, 'handle', handle)
                let cc_info = JSON.parse(JSON.stringify(this.conductForm.cc_info))
                cc_info.forEach(item => {
                    delete item.relate_ids
                    delete item.relate_ids_string
                })
                this.$set(this.approvalProcessNode, 'cc_info',cc_info)
                this.$set(this.approvalProcessNode,'field_auth',this.field_auth)
            }else if(this.approvalProcessType == 'condition'){
                let oldSort = this.approvalProcessNode.sort //本来的sort
                let newSort = this.conditionProcessForm.sort //变为的sort
                this.$set(this.approvalProcessNode, 'sort', this.conditionProcessForm.sort)
                this.$set(this.approvalProcessNode, 'name', this.conditionProcessForm.name)
                this.$set(this.approvalProcessNode, 'rules', JSON.parse(JSON.stringify(this.conditionProcessForm.rules)))
                this.$set(this.approvalProcessNode, 'rulesText', this.rulesTextFunction(this.conditionProcessForm.rules,)) //条件文本

                this.conditionProcessForm = JSON.parse(JSON.stringify(this.$options.data().conditionProcessForm))
                let nodeInfo = this.findParentNodeById(this.nodeInfoData, this.approvalProcessNode.uuid) //找到当前节点的父节点
                this.swapElements(nodeInfo.conditionNodes, oldSort, newSort) //切换优先级的时候要换位置
                this.recursionData(this.nodeInfoData) //重新更新一下全部流程
            }else if(this.approvalProcessType == 'end'){
                  let cc_info = JSON.parse(JSON.stringify(this.endProcessForm.cc_info))
                cc_info.forEach(item => {
                    delete item.relate_ids
                    delete item.relate_ids_string
                })
                this.$set(this.approvalProcessNode, 'cc_info',cc_info)
            }
            this.$message({type: 'success', message: '保存成功', duration: 1000,})
            this.handleClickCancel()
            this.haveEditedBefore() //是否被编辑了
        },
        // 是否编辑了
        haveEditedBefore(){
            this.$emit('editSuccess', true)
        },
        // 校验选择（人员标签，连续多级上级 ，连续多级部门）后 是否选择了值 ,  校验标题是否输入
        roleVerification(data) {

            var flag = true
            if(!data.name){
                this.$message.error('请输入标题')
                flag = false
            }
            if (data.handle && data.handle.type && (data.handle.type == 'user_tags' || data.handle.type == 'successive_superior' || data.handle.type == 'successive_department' || data.handle.type == 'specified')) {
               if (data.handle.relate_id && data.handle.relate_id.length == 0) {
                    let label_text = this.userTypeList.find(find => find.value == data.handle.type).label
                    this.$message({type: 'error', message: `请选择${data.name}：${label_text},并提交`, duration: 1000,})
                    flag = false
               }
            }else if(data.handle && data.handle.type && data.handle.type == 'submitter_choice' && data.handle.is_all_company == 2){
                if (data.handle.relate_id && data.handle.relate_id.length == 0) {
                    let label_text = this.userTypeList.find(find => find.value == data.handle.type).label
                    this.$message({type: 'error', message: `请选择${data.name}：${label_text},并提交`, duration: 1000,})
                    flag = false
               }
            }
            data.cc_info.forEach((item, key) => {
                if ((item.type == 'user_tags' || item.type == 'successive_superior' || item.type == 'successive_department' || item.type == 'specified') && flag) {
                    if (item.relate_id && item.relate_id.length == 0) {
                        let label_text = this.userTypeList.find(find => find.value == item.type).label
                        this.$message({type: 'error', message: `请选择${data.name}抄送人：${label_text},并提交`, duration: 1000,})
                        flag = false
                    }
                }else if(item.type == 'submitter_choice' && item.is_all_company == 2  && flag){
                    if (item.relate_id && item.relate_id.length == 0) {
                        let label_text = this.userTypeList.find(find => find.value == item.type).label
                        this.$message({type: 'error', message: `请选择${data.name}抄送人：${label_text},并提交`, duration: 1000,})
                        flag = false
                    }
                }
            })
            return flag
        },
        // 条件分支获取条件的文本  check = 是否校验，默认校验
        rulesTextFunction(rules,check = 'check') {
            let rulesArr = rules.flat();
            let stringArr = []
            rulesArr.forEach((item, key) => {
                let operator_text = fieldOperatorText(item.operator)
                let field_value = ''
                if(item.field_type == "department" || item.field_type == "promoter"){
                    field_value = item.field_value.titles
                }else if(item.field_type == "date" || item.field_type == 'attendance_date'){
                    field_value = item.field_value.value == 1 ? '表单提交时间' : item.field_value.date
                }else if(item.field_type == "checkbox" || item.field_type == "radio" || item.field_type == "order_after_sale"){
                    field_value = item.field_value.text.join(',')
                }else{
                    field_value = item.field_value
                }
                if (item.field_name != '' && operator_text != '' && field_value != '') {
                    let str = `${item.field_name}${operator_text}${field_value}`
                    stringArr.push(str)
                }
            })
            if ((stringArr.length == 0 || rulesArr.length != stringArr.length) && check == 'check') {
                this.$message({type: 'error', message: `请把条件规则补充完整`, duration: 2000,})
                return false
            } else {
                return stringArr.join(',')
            }
        },
        // 条件切换优先级的时候要换位置
        swapElements(arr, index1, index2) {
            if (index1 >= 0 && index1 < arr.length && index2 >= 0 && index2 < arr.length) {
                [arr[index1], arr[index2]] = [arr[index2], arr[index1]]; // 使用解构赋值交换位置
            }
        },
        // 校验审批流程是否都已编辑完毕
        nodeInfoDataValidate(node) {
            if(node.type != 'condition' && node.type != 'end'){
                this.verificationFieldAuth(node)
            }
            if (node.type == 'condition' && node.name != '默认条件' && (node.rules.length == 0 || node.rulesText == '') && this.nodeValidate) {
                this.nodeValidate = false
                this.$message({type: 'error', message: `请添加${node.name}条件规则`, duration: 2000,})
            }
            if ((node.type != 'start' && node.type != 'end') && (!node.handle || !node.handle.type) && node.type != 'condition' && node.type != 'route' && this.nodeValidate) {
                this.nodeValidate = false
                this.$message({type: 'error', message: `请提交保存${node.name}的设置`, duration: 2000,})
            }

            // 人员标签被自动删除后，校验
            if(node.handle && node.handle.type == 'user_tags' && node.handle.relate_id && node.handle.relate_id.length == 0 && this.nodeValidate){
                this.nodeValidate = false
                this.$message({type: 'error', message: `请选择${node.name}节点的人员标签`, duration: 2000,})
            }
            if(node.cc_info && node.cc_info.length>0){
                let ccNode =  node.cc_info.find(find => find.type == 'user_tags' && (find.relate_id && find.relate_id.length == 0))
                if(ccNode && this.nodeValidate){
                    this.nodeValidate = false
                    this.$message({type: 'error', message: `请选择${node.name}节点的抄送人的人员标签`, duration: 2000,})
                }
            }


            if (node.childNode && node.childNode.type) {
                this.nodeInfoDataValidate(node.childNode);
            }
            if (node.conditionNodes && node.conditionNodes.length > 0) {
                for (let i = 0; i < node.conditionNodes.length; i++) {
                    this.nodeInfoDataValidate(node.conditionNodes[i]);
                }
            }
        },
        // 发布时检查流程中设置的表单权限的字段是否还存在
        verificationFieldAuth(node){
            if(node.type == 'start'){
                if(this.approvalType == 'order_add' || this.approvalType == 'order_purchase'){return false}
            }
            let fieldAuthList =[]
            if(this.approvalType == '' || this.approvalType == 'order_add' || this.approvalType == 'order_purchase'){
                if(this.approvalType == 'order_add'){  //订单编辑
                    let field_list_filter = []
                    this.fieldList.forEach(item=>{
                        if(item._child){
                            field_list_filter = field_list_filter.concat(item._child)
                        }
                    })
                    // 允许设置的字段
                    // 产品信息、代采销售金额、合同、是否需要发货、收货人、收货人电话、收货地址、其他自定义字段、自定义订单金额
                    field_list_filter.forEach(item=>{
                        if(item.field_key == 'contract_file' || item.field_key == 'order_goods' || item.field_key == 'purchase_price' || item.p_field_key == 'receive_information' || item.is_system == 0){
                            fieldAuthList.push(item)
                        }
                    })
                } else if(this.approvalType == 'order_purchase'){ //订单代采
                    fieldAuthList = [
                        {field_key: "supplier",field_name: "供应商"},
                        {field_key: "goods_name",field_name: "产品名称"},
                        {field_key: "price",field_name: "单价"},
                        {field_key: "num",field_name: "数量"},
                        {field_key: "discount_price",field_name: "总优惠金额"},
                        {field_key: "remarks",field_name: "备注"},
                        {field_key: "file",field_name: "附件"},
                    ]
                }else{
                    fieldAuthList = this.fieldList
                }
                // 创建一个 fieldList 的键集合
                let fieldListKeys = new Set(fieldAuthList.map(item => item.field_key));
                // 更新 field_auth，移除不在 fieldList 中的项
                node.field_auth = node.field_auth ? node.field_auth.filter(item => fieldListKeys.has(item.field_key)) : [];
                // 查找 fieldList 中缺少的 field_auth 项
                fieldAuthList.forEach(item => {
                    if (!node.field_auth.some(auth => auth.field_key === item.field_key)) {
                        node.field_auth.push({field_key: item.field_key, field_auth: node.type == 'start' ? 2 : 1});
                    }
                });
            }

        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/approval.scss";
</style>
